// import React, { useRef, useState, useEffect, useCallback } from 'react';
// import axios from 'axios';
// import { useAuth } from '../context/AuthContext';
// import {
//     Box, Typography, Grid, Card, CardMedia, CardContent, Chip, MenuItem, Select,
//     FormControl, Dialog, DialogContent, Button, IconButton, Snackbar, Alert, Fade,
//     Zoom, Skeleton, Tooltip, useTheme, useMediaQuery, CircularProgress
// } from '@mui/material';
// import {
//     CheckCircle, Close, ZoomIn, ZoomOut, OpenInFull, FilePresent, KeyboardArrowDown,
//     AutoAwesome, BarChart
// } from '@mui/icons-material';

// // ─── DESIGN TOKENS ────────────────────────────────────────────────────────────
// const FB = "#1877F2";
// const FB_DARK = "#0B5CD6";
// const FB_LIGHT = "#EAF2FE";
// const FB_MID = "#9EC5FB";
// const BG = "#F5FAFE";
// const BORDER = "#E1E8EF";
// const T1 = "#1C2B39";
// const T2 = "#5B6B7B";
// const GREEN = "#12805C";
// const GREEN_LT = "#E6F6F0";
// const RED = "#E24B4A";

// // ─── CONSTANTS ────────────────────────────────────────────────────────────────
// const publicUrl = typeof process !== 'undefined' && process.env?.PUBLIC_URL ? process.env.PUBLIC_URL : '';
// const dummyImg = `${publicUrl}/Quotation_Image.jpeg`;

// const getImageForTypeFormat = (type = '', format = 0) => {
//     const idx = Number(format) || 0;
//     if (!idx || idx < 1 || idx > 10) return { thumb: dummyImg, large: dummyImg };
//     const norm = (type || '').replace(/\s+/g, '').toLowerCase();
//     const build = (base) => `${publicUrl}/${base}${idx}.jpg`;
//     const map = {
//         quotation: () => build('Quotation'),
//         saleorder: () => build('SaleOrder'),
//         proformainvoice: () => build('ProformaInvoice'),
//         salechallan: () => build('SaleChallan'),
//         saleinvoice: () => build('SaleInvoice'),
//         creditnote: () => build('CreditNote'),
//         purchaseorder: () => build('PurchaseOrder'),
//         purchasedispatch: () => build('PurchaseChallan'),
//         purchaseinvoice: () => build('PurchaseInvoice'),
//         debitnote: () => build('DebitNote'),
//     };
//     const src = map[norm] ? map[norm]() : dummyImg;
//     return { thumb: src, large: src };
// };

// const documentTypes = [
//     'Quotation',
//     'Proforma Invoice',
//     'Sale Challan',
//     'Sale Invoice',
// ];

// // Document types that support multiple series
// const MULTI_SERIES_TYPES = ['Sale Challan', 'Sale Invoice', 'Proforma Invoice', 'Credit Note'];

// const FORMAT_COUNT = 10;
// const formats = Array.from({ length: FORMAT_COUNT }, (_, i) => i + 1);

// // ─── SHARED SX ────────────────────────────────────────────────────────────────
// const cardBaseSx = {
//     background: "#fff", border: `0.5px solid ${BORDER}`, borderRadius: "12px",
// };

// const btnPrimarySx = {
//     background: FB, color: "#fff", borderRadius: "8px", fontSize: 13, fontWeight: 500,
//     textTransform: "none", px: 2.5, height: 38,
//     "&:hover": { background: FB_DARK },
//     "&:disabled": { background: FB_MID, color: "#fff" },
// };

// const btnGhostSx = {
//     background: "transparent", color: T2, border: `0.5px solid ${BORDER}`, borderRadius: "8px",
//     fontSize: 13, fontWeight: 500, textTransform: "none", px: 2.5, height: 38,
//     "&:hover": { background: "#fff", color: T1 },
// };

// // ─── SERIES CARD ──────────────────────────────────────────────────────────────
// function SeriesCard({ series, isSelected, appliedFormat, onClick, index }) {
//     const seriesName = series?.SeriesName || series?.seriesName || series?.Name || series?.name || `Series ${series?.SeriesId || series?.SeriesID || index + 1}`;
//     const seriesId = series?.SeriesId || series?.SeriesID || series?.seriesId || series?.Id || series?.id || index + 1;

//     return (
//         <Zoom in style={{ transitionDelay: `${index * 40}ms` }}>
//             <Card
//                 onClick={() => onClick(series)}
//                 sx={{
//                     cursor: "pointer", borderRadius: "12px", overflow: "hidden",
//                     border: isSelected ? `2px solid ${FB}` : `0.5px solid ${BORDER}`,
//                     outline: isSelected ? `4px solid ${FB_LIGHT}` : "none",
//                     boxShadow: "none", transition: "all 0.2s ease",
//                     "&:hover": {
//                         boxShadow: `0 6px 24px rgba(24,119,242,0.14)`,
//                         transform: "translateY(-4px)", borderColor: FB,
//                     },
//                     background: "#fff", p: 2,
//                 }}
//             >
//                 <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//                         <Box sx={{
//                             width: 40, height: 40, borderRadius: "10px",
//                             bgcolor: isSelected ? FB : FB_LIGHT,
//                             display: "flex", alignItems: "center", justifyContent: "center",
//                             transition: "all 0.2s ease",
//                         }}>
//                             <BarChart sx={{ fontSize: 20, color: isSelected ? "#fff" : FB }} />
//                         </Box>
//                         <Box>
//                             <Typography sx={{ fontSize: 14, fontWeight: 500, color: T1, lineHeight: 1.3 }}>
//                                 {seriesName}
//                             </Typography>
//                             <Typography sx={{ fontSize: 11, color: T2 }}>
//                                 Series ID: {seriesId}
//                             </Typography>
//                         </Box>
//                     </Box>
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                         {appliedFormat && (
//                             <Chip
//                                 icon={<CheckCircle sx={{ fontSize: 13, color: `${GREEN} !important` }} />}
//                                 label={`Format ${appliedFormat}`}
//                                 size="small"
//                                 sx={{
//                                     fontSize: 11, fontWeight: 500, height: 24,
//                                     bgcolor: GREEN_LT, color: GREEN,
//                                     border: `0.5px solid ${GREEN}44`,
//                                     "& .MuiChip-icon": { ml: "6px" },
//                                 }}
//                             />
//                         )}
//                         {isSelected && (
//                             <Box sx={{
//                                 width: 24, height: 24, borderRadius: "50%", bgcolor: FB,
//                                 display: "flex", alignItems: "center", justifyContent: "center",
//                             }}>
//                                 <CheckCircle sx={{ color: "#fff", fontSize: 16 }} />
//                             </Box>
//                         )}
//                     </Box>
//                 </Box>
//             </Card>
//         </Zoom>
//     );
// }

// // ─── FORMAT CARD ──────────────────────────────────────────────────────────────
// function FormatCard({ format, selectedType, isApplied, onClick }) {
//     const [imgLoaded, setImgLoaded] = useState(false);
//     const { thumb } = getImageForTypeFormat(selectedType, format);

//     return (
//         <Zoom in style={{ transitionDelay: `${(format - 1) * 40}ms` }}>
//             <Card
//                 onClick={onClick}
//                 sx={{
//                     cursor: "pointer", borderRadius: "12px", overflow: "hidden",
//                     border: isApplied ? `2px solid ${FB}` : `0.5px solid ${BORDER}`,
//                     outline: isApplied ? `4px solid ${FB_LIGHT}` : "none",
//                     boxShadow: "none", transition: "all 0.2s ease",
//                     "&:hover": {
//                         boxShadow: `0 6px 24px rgba(24,119,242,0.14)`,
//                         transform: "translateY(-4px)", borderColor: FB,
//                     },
//                     position: "relative", background: "#fff",
//                 }}
//             >
//                 <Box sx={{ position: "relative", bgcolor: BG, height: { xs: 160, sm: 200, md: 220 }, overflow: "hidden" }}>
//                     {!imgLoaded && (
//                         <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" sx={{ bgcolor: FB_LIGHT }} />
//                     )}
//                     <CardMedia component="img" image={thumb} alt={`Format ${format}`}
//                         onLoad={() => setImgLoaded(true)}
//                         onError={(e) => { e.currentTarget.src = dummyImg; setImgLoaded(true); }}
//                         sx={{
//                             height: "100%", objectFit: "cover",
//                             display: imgLoaded ? "block" : "none",
//                             transition: "transform 0.3s ease",
//                             "&:hover": { transform: "scale(1.04)" },
//                         }}
//                     />
//                     <Box sx={{
//                         position: "absolute", inset: 0,
//                         background: "linear-gradient(to top, rgba(24,119,242,0.25) 0%, transparent 50%)",
//                         pointerEvents: "none",
//                     }} />
//                     <Box sx={{
//                         position: "absolute", top: 10, left: 10, px: "8px", py: "3px",
//                         background: isApplied ? FB : "rgba(255,255,255,0.9)",
//                         borderRadius: "6px", border: `0.5px solid ${isApplied ? FB : BORDER}`,
//                     }}>
//                         <Typography sx={{ fontSize: 11, fontWeight: 500, color: isApplied ? "#fff" : T2 }}>
//                             Format {format}
//                         </Typography>
//                     </Box>
//                     {isApplied && (
//                         <Box sx={{
//                             position: "absolute", top: 10, right: 10,
//                             width: 28, height: 28, borderRadius: "50%",
//                             bgcolor: GREEN, display: "flex",
//                             alignItems: "center", justifyContent: "center",
//                         }}>
//                             <CheckCircle sx={{ color: "#fff", fontSize: 18 }} />
//                         </Box>
//                     )}
//                 </Box>
//                 <CardContent sx={{ py: 1.25, px: 1.5, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//                     <Typography sx={{ fontSize: 13, fontWeight: 500, color: T1 }}>
//                         Format {format}
//                     </Typography>
//                     {isApplied ? (
//                         <Chip
//                             icon={<CheckCircle sx={{ fontSize: 14, color: `${GREEN} !important` }} />}
//                             label="Active"
//                             size="small"
//                             sx={{
//                                 fontSize: 11, fontWeight: 500, height: 22,
//                                 bgcolor: GREEN_LT, color: GREEN,
//                                 border: `0.5px solid ${GREEN}44`,
//                                 "& .MuiChip-icon": { ml: "6px" },
//                             }}
//                         />
//                     ) : (
//                         <Chip
//                             label="Preview"
//                             size="small"
//                             sx={{
//                                 fontSize: 11, height: 22,
//                                 bgcolor: FB_LIGHT, color: FB,
//                                 border: `0.5px solid ${FB_MID}`,
//                             }}
//                         />
//                     )}
//                 </CardContent>
//             </Card>
//         </Zoom>
//     );
// }

// // ─── PREVIEW DIALOG ───────────────────────────────────────────────────────────
// function PreviewDialog({ open, onClose, selectedType, selectedFormat, onApply, appliedFormat, selectedSeries }) {

//     // ── All values stored in refs so event listeners always see latest values ──
//     const scaleRef = useRef(1);
//     const originRef = useRef({ x: 50, y: 50 });
//     const translateRef = useRef({ x: 0, y: 0 });
//     const isDraggingRef = useRef(false);
//     const dragStartRef = useRef({ mouseX: 0, mouseY: 0, translateX: 0, translateY: 0 });

//     // ── React state only for triggering re-renders ──
//     const [scale, setScale] = useState(1);
//     const [origin, setOrigin] = useState({ x: 50, y: 50 });
//     const [translate, setTranslate] = useState({ x: 0, y: 0 });
//     const [isDragging, setIsDragging] = useState(false);

//     const containerRef = useRef(null);

//     const { large } = getImageForTypeFormat(selectedType, selectedFormat);
//     const isAlreadyApplied = appliedFormat === selectedFormat;
//     const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'));
//     const isMultiSeries = MULTI_SERIES_TYPES.includes(selectedType);
//     const seriesName = selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || selectedSeries?.name || '';

//     // ── Master reset ──────────────────────────────────────────────────────────
//     const resetAll = useCallback(() => {
//         scaleRef.current = 1;
//         originRef.current = { x: 50, y: 50 };
//         translateRef.current = { x: 0, y: 0 };
//         isDraggingRef.current = false;
//         setScale(1);
//         setOrigin({ x: 50, y: 50 });
//         setTranslate({ x: 0, y: 0 });
//         setIsDragging(false);
//     }, []);

//     // ── Reset when dialog closes ──────────────────────────────────────────────
//     useEffect(() => {
//         if (!open) resetAll();
//     }, [open, resetAll]);

//     // ── Get pointer position as % inside the container ────────────────────────
//     const getPointerOrigin = useCallback((clientX, clientY) => {
//         const container = containerRef.current;
//         if (!container) return { x: 50, y: 50 };
//         const rect = container.getBoundingClientRect();
//         const x = Math.min(Math.max(((clientX - rect.left) / rect.width) * 100, 0), 100);
//         const y = Math.min(Math.max(((clientY - rect.top) / rect.height) * 100, 0), 100);
//         return { x, y };
//     }, []);

//     // ── Core zoom function — reads/writes refs, then syncs state ──────────────
//     const applyZoom = useCallback((delta, pointerOrigin) => {
//         const newScale = Math.min(Math.max(scaleRef.current * delta, 0.4), 5);
//         scaleRef.current = newScale;

//         if (pointerOrigin) {
//             originRef.current = pointerOrigin;
//             setOrigin({ ...pointerOrigin });
//         }

//         // Auto-reset translation when fully zoomed out
//         if (newScale <= 1) {
//             translateRef.current = { x: 0, y: 0 };
//             setTranslate({ x: 0, y: 0 });
//         }

//         setScale(newScale);
//     }, []);

//     // ── Wheel handler — defined with useCallback so it is stable ─────────────
//     const handleWheel = useCallback((e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         const po = getPointerOrigin(e.clientX, e.clientY);
//         const delta = e.deltaY > 0 ? 0.93 : 1.07;
//         applyZoom(delta, po);
//     }, [getPointerOrigin, applyZoom]);

//     // ── Attach wheel listener with { passive: false } on the container ────────
//     // Re-attach whenever handleWheel changes (it's stable, so this runs once per open)
//     useEffect(() => {
//         const el = containerRef.current;
//         if (!el || !open) return;
//         el.addEventListener('wheel', handleWheel, { passive: false });
//         return () => {
//             el.removeEventListener('wheel', handleWheel);
//         };
//     }, [open, handleWheel]);

//     // ── Button zoom — uses last known pointer origin ──────────────────────────
//     const handleZoomIn = useCallback(() => {
//         applyZoom(1.25, originRef.current);
//     }, [applyZoom]);

//     const handleZoomOut = useCallback(() => {
//         applyZoom(0.8, originRef.current);
//     }, [applyZoom]);

//     const handleReset = useCallback(() => {
//         resetAll();
//     }, [resetAll]);

//     // ── Mouse move — track pointer for button-zoom aim + handle drag ──────────
//     const handleMouseMove = useCallback((e) => {
//         if (!isDraggingRef.current) {
//             // Keep origin ref updated so button zooms aim at cursor
//             originRef.current = getPointerOrigin(e.clientX, e.clientY);
//             return;
//         }
//         // While dragging compute new translation
//         const dx = e.clientX - dragStartRef.current.mouseX;
//         const dy = e.clientY - dragStartRef.current.mouseY;
//         const newTranslate = {
//             x: dragStartRef.current.translateX + dx,
//             y: dragStartRef.current.translateY + dy,
//         };
//         translateRef.current = newTranslate;
//         setTranslate({ ...newTranslate });
//     }, [getPointerOrigin]);

//     // ── Mouse down — begin drag only when zoomed in ───────────────────────────
//     const handleMouseDown = useCallback((e) => {
//         if (scaleRef.current <= 1) return;
//         e.preventDefault();
//         isDraggingRef.current = true;
//         setIsDragging(true);
//         dragStartRef.current = {
//             mouseX: e.clientX,
//             mouseY: e.clientY,
//             translateX: translateRef.current.x,
//             translateY: translateRef.current.y,
//         };
//     }, []);

//     // ── Mouse up — stop drag the instant button is released ──────────────────
//     const handleMouseUp = useCallback(() => {
//         if (!isDraggingRef.current) return;
//         isDraggingRef.current = false;
//         setIsDragging(false);
//     }, []);

//     // ── Mouse leave — stop drag so image never gets stuck ────────────────────
//     const handleMouseLeave = useCallback(() => {
//         if (!isDraggingRef.current) return;
//         isDraggingRef.current = false;
//         setIsDragging(false);
//     }, []);

//     // ── Touch handlers (mobile) ───────────────────────────────────────────────
//     const handleTouchStart = useCallback((e) => {
//         if (scaleRef.current <= 1 || e.touches.length !== 1) return;
//         const touch = e.touches[0];
//         isDraggingRef.current = true;
//         setIsDragging(true);
//         dragStartRef.current = {
//             mouseX: touch.clientX,
//             mouseY: touch.clientY,
//             translateX: translateRef.current.x,
//             translateY: translateRef.current.y,
//         };
//     }, []);

//     const handleTouchMove = useCallback((e) => {
//         if (!isDraggingRef.current || e.touches.length !== 1) return;
//         e.preventDefault();
//         const touch = e.touches[0];
//         const dx = touch.clientX - dragStartRef.current.mouseX;
//         const dy = touch.clientY - dragStartRef.current.mouseY;
//         const newTranslate = {
//             x: dragStartRef.current.translateX + dx,
//             y: dragStartRef.current.translateY + dy,
//         };
//         translateRef.current = newTranslate;
//         setTranslate({ ...newTranslate });
//     }, []);

//     const handleTouchEnd = useCallback(() => {
//         isDraggingRef.current = false;
//         setIsDragging(false);
//     }, []);

//     // ── Attach touchmove with { passive: false } so preventDefault works ──────
//     useEffect(() => {
//         const el = containerRef.current;
//         if (!el || !open) return;
//         el.addEventListener('touchmove', handleTouchMove, { passive: false });
//         return () => {
//             el.removeEventListener('touchmove', handleTouchMove);
//         };
//     }, [open, handleTouchMove]);

//     // ─────────────────────────────────────────────────────────────────────────
//     return (
//         <Dialog
//             open={open}
//             onClose={onClose}
//             maxWidth="md"
//             fullWidth
//             fullScreen={isMobile}
//             TransitionComponent={Fade}
//             PaperProps={{
//                 sx: {
//                     borderRadius: isMobile ? 0 : "14px",
//                     overflow: "hidden",
//                     maxHeight: isMobile ? "100vh" : "92vh",
//                     border: `0.5px solid ${BORDER}`,
//                 }
//             }}
//         >
//             {/* ── Header ── */}
//             <Box sx={{
//                 display: "flex", alignItems: "center", justifyContent: "space-between",
//                 px: { xs: 2, sm: 3 }, py: 1.75,
//                 background: FB, color: "#fff",
//                 borderBottom: `1.5px solid ${FB_DARK}`,
//             }}>
//                 <Box>
//                     <Typography sx={{ fontSize: 15, fontWeight: 500, color: "#fff" }}>
//                         {selectedType}
//                         {isMultiSeries && seriesName && (
//                             <Box component="span" sx={{ ml: 1, fontSize: 12, color: "rgba(255,255,255,0.75)" }}>
//                                 — {seriesName}
//                             </Box>
//                         )}
//                     </Typography>
//                     <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.7)" }}>
//                         Format {selectedFormat}
//                     </Typography>
//                 </Box>
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//                     <Tooltip title="Zoom out">
//                         <IconButton size="small" sx={{ color: "#fff" }} onClick={handleZoomOut}>
//                             <ZoomOut sx={{ fontSize: 18 }} />
//                         </IconButton>
//                     </Tooltip>
//                     <Box sx={{
//                         px: "8px", py: "3px", bgcolor: "rgba(255,255,255,0.15)",
//                         borderRadius: "6px", mx: 0.5,
//                     }}>
//                         <Typography sx={{ fontSize: 12, fontWeight: 500, color: "#fff", minWidth: 40, textAlign: "center" }}>
//                             {Math.round(scale * 100)}%
//                         </Typography>
//                     </Box>
//                     <Tooltip title="Zoom in">
//                         <IconButton size="small" sx={{ color: "#fff" }} onClick={handleZoomIn}>
//                             <ZoomIn sx={{ fontSize: 18 }} />
//                         </IconButton>
//                     </Tooltip>
//                     <Tooltip title="Reset">
//                         <IconButton size="small" sx={{ color: "#fff" }} onClick={handleReset}>
//                             <OpenInFull sx={{ fontSize: 16 }} />
//                         </IconButton>
//                     </Tooltip>
//                     <IconButton size="small" sx={{ color: "#fff", ml: 0.5 }} onClick={onClose}>
//                         <Close sx={{ fontSize: 18 }} />
//                     </IconButton>
//                 </Box>
//             </Box>

//             {/* ── Image / drag area ── */}
//             <DialogContent
//                 ref={containerRef}
//                 sx={{
//                     p: 0,
//                     bgcolor: BG,
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     minHeight: isMobile ? "calc(100vh - 140px)" : 400,
//                     overflow: "hidden",
//                     cursor: isDragging ? "grabbing" : scale > 1 ? "grab" : "zoom-in",
//                     position: "relative",
//                     userSelect: "none",
//                 }}
//                 onMouseMove={handleMouseMove}
//                 onMouseDown={handleMouseDown}
//                 onMouseUp={handleMouseUp}
//                 onMouseLeave={handleMouseLeave}
//                 onTouchStart={handleTouchStart}
//                 onTouchEnd={handleTouchEnd}
//             >
//                 <Box
//                     sx={{
//                         // No transition while dragging for instant response
//                         transition: isDragging ? "none" : "transform 0.12s ease",
//                         transform: `translate(${translate.x}px, ${translate.y}px) scale(${scale})`,
//                         transformOrigin: `${origin.x}% ${origin.y}%`,
//                         display: "inline-block",
//                         lineHeight: 0,
//                         // Prevent the inner box from catching pointer events
//                         pointerEvents: "none",
//                     }}
//                 >
//                     <img
//                         src={large}
//                         alt="Preview"
//                         draggable={false}
//                         onError={(e) => { e.currentTarget.src = dummyImg; }}
//                         style={{
//                             maxWidth: "100%",
//                             maxHeight: isMobile ? "70vh" : "60vh",
//                             objectFit: "contain",
//                             display: "block",
//                             userSelect: "none",
//                             pointerEvents: "none",
//                         }}
//                     />
//                 </Box>
//             </DialogContent>

//             {/* ── Footer ── */}
//             <Box sx={{
//                 px: { xs: 2, sm: 3 }, py: 2,
//                 display: "flex", gap: 1.5, justifyContent: "flex-end",
//                 borderTop: `0.5px solid ${BORDER}`, bgcolor: "#fff",
//                 flexWrap: "wrap",
//             }}>
//                 <Button onClick={onClose} sx={btnGhostSx}>Cancel</Button>
//                 <Button
//                     onClick={onApply}
//                     disabled={isAlreadyApplied}
//                     startIcon={isAlreadyApplied
//                         ? <CheckCircle sx={{ fontSize: 16 }} />
//                         : <AutoAwesome sx={{ fontSize: 16 }} />}
//                     sx={{
//                         ...btnPrimarySx,
//                         ...(isAlreadyApplied && {
//                             bgcolor: GREEN_LT, color: GREEN,
//                             border: `0.5px solid ${GREEN}44`,
//                             "&:disabled": { bgcolor: GREEN_LT, color: GREEN }
//                         }),
//                     }}
//                 >
//                     {isAlreadyApplied ? "Currently active" : "Apply template"}
//                 </Button>
//             </Box>
//         </Dialog>
//     );
// }

// // ─── MAIN ─────────────────────────────────────────────────────────────────────
// export default function FormatSelectionScreen({ loggedInUser, companyData, connectionString }) {
//     const API = connectionString;
//     const auth = useAuth();
//     const { selectedCompany } = useAuth();
//     const authSelectedCompany = auth?.selectedCompany ?? null;
//     const muiTheme = useTheme();
//     const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
//     const isTablet = useMediaQuery(muiTheme.breakpoints.down('md'));

//     const [selectedType, setSelectedType] = useState('');
//     const [selectedFormat, setSelectedFormat] = useState(null);
//     const [appliedFormat, setAppliedFormat] = useState(null);
//     const [previewOpen, setPreviewOpen] = useState(false);
//     const [snack, setSnack] = useState({ open: false, msg: '', severity: 'success' });

//     // Multi-series states
//     const [seriesList, setSeriesList] = useState([]);
//     const [selectedSeries, setSelectedSeries] = useState(null);
//     const [seriesFormats, setSeriesFormats] = useState({});
//     const [loadingSeries, setLoadingSeries] = useState(false);

//     const AppRegID = selectedCompany?.AppRegID || null;
//     const isMultiSeriesType = MULTI_SERIES_TYPES.includes(selectedType);

//     // ── Company resolution ────────────────────────────────────────────────────
//     const companyFromProp = Array.isArray(companyData) ? companyData[0] : (companyData || null);
//     let fallbackLS = null;
//     try {
//         const s = typeof window !== 'undefined' ? window.localStorage.getItem('selectedCompany') : null;
//         if (s) fallbackLS = JSON.parse(s);
//     } catch { fallbackLS = null; }

//     const companyObj = authSelectedCompany || companyFromProp
//         || (loggedInUser && (loggedInUser.selectedCompany || loggedInUser.company || loggedInUser.companyData))
//         || fallbackLS || {};

//     const tryNum = (v) => { if (v == null || v === '') return 0; const n = Number(v); return isFinite(n) ? n : 0; };
//     const GCompId_RAW = companyObj?.GCompId ?? companyObj?.GCompid ?? companyObj?.GCompID ?? null;
//     const GCompId = (GCompId_RAW == null || GCompId_RAW === '') ? null : tryNum(GCompId_RAW);

//     let CompId = 0;
//     for (const c of [companyObj?.CompId, companyObj?.CompID, companyObj?.Compid, companyObj?.CompanyId, loggedInUser?.CompId, loggedInUser?.CompanyId]) {
//         const n = tryNum(c);
//         if (n > 0) { CompId = n; break; }
//     }
//     if (!CompId && fallbackLS) {
//         for (const c of [fallbackLS?.CompId, fallbackLS?.CompID, fallbackLS?.CompanyId]) {
//             const n = tryNum(c);
//             if (n > 0) { CompId = n; break; }
//         }
//     }

//     const CURRENT_USER_ID = Number(loggedInUser?.UserId ?? loggedInUser?.UserID ?? 0);
//     const toMySqlDT = (d) => {
//         const p = (n) => String(n).padStart(2, '0');
//         return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
//     };

//     const getBookNameKey = (type, series = null) => {
//         const base = type.replace(/\s+/g, '');
//         if (series) {
//             const seriesId = series?.SeriesId || series?.SeriesID || series?.seriesId || series?.Id || series?.id || 0;
//             return `${base}_Series_${seriesId}`;
//         }
//         return base;
//     };

//     const getSeriesId = (series) => {
//         return series?.SeriesId || series?.SeriesID || series?.seriesId || series?.Id || series?.id || 0;
//     };

//     // ── Fetch series ──────────────────────────────────────────────────────────
//     const fetchSeriesForType = async (type) => {
//         setLoadingSeries(true);
//         setSeriesList([]);
//         setSelectedSeries(null);
//         setSeriesFormats({});
//         try {
//             const companyIdParam = CompId || 0;
//             const typeNorm = type.replace(/\s+/g, '');
//             const resp = await axios.get(`${API}/api/seriesForPDF`, {
//                 params: { companyId: companyIdParam, documentType: typeNorm },
//                 timeout: 15000,
//             });

//             let arr = [];
//             if (resp?.data) {
//                 if (Array.isArray(resp.data.series)) arr = resp.data.series;
//                 else if (Array.isArray(resp.data)) arr = resp.data;
//                 else if (Array.isArray(resp.data.data)) arr = resp.data.data;
//             }
//             setSeriesList(arr);

//             if (arr.length > 0) {
//                 try {
//                     const fmtResp = await axios.get(`${API}/api/companies`, {
//                         params: { companyId: companyIdParam },
//                         timeout: 15000,
//                     });
//                     let companies = [];
//                     if (fmtResp?.data) {
//                         if (Array.isArray(fmtResp.data.companies)) companies = fmtResp.data.companies;
//                         else if (Array.isArray(fmtResp.data)) companies = fmtResp.data;
//                         else if (Array.isArray(fmtResp.data.data)) companies = fmtResp.data.data;
//                     }
//                     const wantedId = Number(CompId || companyIdParam || 0);
//                     const rec = companies.find(c => tryNum(c?.CompId ?? c?.CompID ?? 0) === wantedId) || companies[0];
//                     if (rec && Array.isArray(rec.formats)) {
//                         const norm = (s) => String(s || '').replace(/\s+/g, '').toLowerCase();
//                         const fmtMap = {};
//                         for (const series of arr) {
//                             const sId = getSeriesId(series);
//                             const wantedBookName = norm(typeNorm);
//                             for (const f of rec.formats) {
//                                 const bName = norm(f?.BookName ?? '');
//                                 const bId = Number(f?.BookID ?? f?.BookId ?? 0);
//                                 const fSeriesId = Number(f?.SeriesId ?? f?.seriesId ?? 0);
//                                 if (bId && bName === wantedBookName && fSeriesId === Number(sId)) {
//                                     fmtMap[sId] = bId;
//                                     break;
//                                 }
//                             }
//                             if (!fmtMap[sId]) {
//                                 for (const f of rec.formats) {
//                                     const bName = norm(f?.BookName ?? '');
//                                     const bId = Number(f?.BookID ?? f?.BookId ?? 0);
//                                     const fSeriesId = Number(f?.SeriesId ?? f?.seriesId ?? 0);
//                                     if (bId && bName === wantedBookName && (!fSeriesId || fSeriesId === 0)) {
//                                         fmtMap[sId] = bId;
//                                         break;
//                                     }
//                                 }
//                             }
//                         }
//                         setSeriesFormats(fmtMap);
//                     }
//                 } catch (err) {
//                     console.warn('Error fetching series formats', err?.message);
//                 }
//             }
//         } catch (err) {
//             console.warn('Series API error', err?.response?.data || err?.message);
//             setSeriesList([]);
//             setSelectedSeries(null);
//             setSeriesFormats({});
//             setSnack({ open: true, msg: err?.response?.data?.message || 'Failed to load series.', severity: 'error' });
//         } finally {
//             setLoadingSeries(false);
//         }
//     };

//     // ── Handlers ─────────────────────────────────────────────────────────────
//     const handleSelectType = async (type) => {
//         setSelectedType(type);
//         setSelectedFormat(null);
//         setAppliedFormat(null);
//         setSelectedSeries(null);
//         setSeriesList([]);
//         setSeriesFormats({});

//         if (MULTI_SERIES_TYPES.includes(type)) {
//             await fetchSeriesForType(type);
//         } else {
//             try {
//                 const companyIdParam = CompId || 0;
//                 const resp = await axios.get(`${API}/api/companies`, { params: { companyId: companyIdParam }, timeout: 15000 });
//                 let arr = [];
//                 if (resp?.data) {
//                     if (Array.isArray(resp.data.companies)) arr = resp.data.companies;
//                     else if (Array.isArray(resp.data)) arr = resp.data;
//                     else if (Array.isArray(resp.data.data)) arr = resp.data.data;
//                 }
//                 const wantedId = Number(CompId || companyIdParam || 0);
//                 const rec = arr.find(c => tryNum(c?.CompId ?? c?.CompID ?? 0) === wantedId) || arr[0];
//                 if (rec && Array.isArray(rec.formats)) {
//                     const norm = (s) => String(s || '').replace(/\s+/g, '').toLowerCase();
//                     const wantedNorm = norm(type);
//                     let found = null;
//                     for (const f of rec.formats) {
//                         const bName = norm(f?.BookName ?? '');
//                         const bId = Number(f?.BookID ?? f?.BookId ?? 0);
//                         if (bId && bName === wantedNorm) { found = bId; break; }
//                     }
//                     setAppliedFormat(found ?? 1);
//                 } else {
//                     setAppliedFormat(1);
//                 }
//             } catch (err) {
//                 console.warn('companies API error', err?.message);
//             }
//         }
//     };

//     const handleSelectSeries = (series) => {
//         setSelectedSeries(series);
//         setSelectedFormat(null);
//         const sId = getSeriesId(series);
//         const fmt = seriesFormats[sId] || null;
//         setAppliedFormat(fmt);
//     };

//     const handleCardClick = (format) => {
//         setSelectedFormat(format);
//         setPreviewOpen(true);
//     };

//     const handleApplyTemplate = async () => {
//         if (!selectedType || !selectedFormat) {
//             setSnack({ open: true, msg: 'Select a document type and format first.', severity: 'warning' });
//             return;
//         }
//         if (isMultiSeriesType && !selectedSeries) {
//             setSnack({ open: true, msg: 'Please select a series first.', severity: 'warning' });
//             return;
//         }
//         if (!CompId) {
//             setSnack({ open: true, msg: 'Unable to determine your company. Please select a company first.', severity: 'error' });
//             return;
//         }
//         const now = new Date();
//         const bookName = selectedType.replace(/\s+/g, '');
//         const seriesId = isMultiSeriesType ? getSeriesId(selectedSeries) : null;

//         const payload = {
//             GCompId: null, CompId,
//             BookName: bookName,
//             BookID: Number(selectedFormat),
//             FormName: isMultiSeriesType
//                 ? `${selectedType}-Series-${seriesId}-Format-${selectedFormat}`
//                 : `${selectedType}-Format-${selectedFormat}`,
//             CompDefault: 0, PPO: 0,
//             paperheight: 842, paperwidth: 595,
//             TopMargin: 0, LeftMargin: 0, RightMargin: 0, BottomMargin: 0,
//             Heading: '',
//             AddUserId: CURRENT_USER_ID, AddUserDateTime: toMySqlDT(now),
//             EditUserId: CURRENT_USER_ID, EditUserDateTime: toMySqlDT(now),
//             AppRegID,
//             ...(isMultiSeriesType && seriesId ? { SeriesId: seriesId } : {}),
//         };
//         try {
//             const res = await axios.post(`${API}/api/printmaster`, payload, { headers: { 'Content-Type': 'application/json' }, timeout: 15000 });
//             const ok = res?.data?.success === true || res?.data?.insertId || (res?.data?.affectedRows > 0);
//             if (ok) {
//                 const newFormat = Number(selectedFormat);
//                 setAppliedFormat(newFormat);
//                 if (isMultiSeriesType && selectedSeries) {
//                     const sId = getSeriesId(selectedSeries);
//                     setSeriesFormats(prev => ({ ...prev, [sId]: newFormat }));
//                 }
//                 setPreviewOpen(false);
//                 setSelectedFormat(null);
//                 const seriesLabel = isMultiSeriesType && selectedSeries
//                     ? ` for ${selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || 'series'}`
//                     : '';
//                 setSnack({ open: true, msg: `Format ${selectedFormat} applied successfully${seriesLabel}!`, severity: 'success' });
//             } else {
//                 setSnack({ open: true, msg: res?.data?.message || 'Failed to apply template.', severity: 'error' });
//             }
//         } catch (err) {
//             const msg = err.response?.data?.message || `Server error ${err.response?.status || ''}` || 'Network error.';
//             setSnack({ open: true, msg, severity: 'error' });
//         }
//     };

//     const showFormatGrid = selectedType && (!isMultiSeriesType || (isMultiSeriesType && selectedSeries));

//     const getActiveFormatLabel = () => {
//         if (isMultiSeriesType && selectedSeries) {
//             const sId = getSeriesId(selectedSeries);
//             const fmt = seriesFormats[sId];
//             if (fmt) {
//                 const sName = selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || `Series ${sId}`;
//                 return `Format ${fmt} — ${sName}`;
//             }
//             return null;
//         }
//         if (appliedFormat && selectedType && !isMultiSeriesType) return `Format ${appliedFormat} active`;
//         return null;
//     };

//     const activeLabel = getActiveFormatLabel();

//     // ─── RENDER ───────────────────────────────────────────────────────────────
//     return (
//         <Box sx={{ minHeight: "100vh", background: BG }}>

//             {/* ── TOPBAR ── */}
//             <Box sx={{
//                 background: "#fff", borderBottom: `0.5px solid ${BORDER}`,
//                 px: { xs: 2, sm: 3, md: 4 }, py: 1.5,
//                 display: "flex", alignItems: "center", justifyContent: "space-between",
//             }}>
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
//                     <Box sx={{
//                         width: 36, height: 36, background: FB, borderRadius: "9px",
//                         display: "flex", alignItems: "center", justifyContent: "center"
//                     }}>
//                         <FilePresent sx={{ color: "#fff", fontSize: 19 }} />
//                     </Box>
//                     <Box>
//                         <Typography sx={{ fontSize: 16, fontWeight: 500, color: T1, lineHeight: 1.2 }}>
//                             Printing <Box component="span" sx={{ color: FB }}>utilities</Box>
//                         </Typography>
//                         <Typography sx={{ fontSize: 11, color: T2 }}>
//                             Document template manager
//                         </Typography>
//                     </Box>
//                 </Box>
//                 {activeLabel && (
//                     <Box sx={{
//                         display: "flex", alignItems: "center", gap: "6px",
//                         px: "10px", py: "4px", bgcolor: GREEN_LT, borderRadius: "20px",
//                         border: `0.5px solid ${GREEN}44`,
//                     }}>
//                         <CheckCircle sx={{ fontSize: 13, color: GREEN }} />
//                         <Typography sx={{ fontSize: 12, fontWeight: 500, color: GREEN }}>
//                             {activeLabel}
//                         </Typography>
//                     </Box>
//                 )}
//             </Box>

//             {/* ── CONTENT ── */}
//             <Box sx={{ maxWidth: 1200, mx: "auto", px: { xs: 1.5, sm: 3, md: 4 }, py: { xs: 2, sm: 3, md: 4 } }}>

//                 {/* ── Step 1 — Type selector ── */}
//                 <Box sx={{ ...cardBaseSx, p: { xs: 1.5, sm: 2 }, mb: { xs: 1.5, sm: 2 } }}>
//                     <Typography sx={{
//                         fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".4px", mb: 1,
//                         display: "flex", alignItems: "center", gap: "6px"
//                     }}>
//                         <Box component="span" sx={{ width: 14, height: 14, bgcolor: FB, borderRadius: "4px", display: "inline-block" }} />
//                         Step 1 — Select document type
//                     </Typography>

//                     <FormControl fullWidth size="small">
//                         <Select value={selectedType} onChange={(e) => handleSelectType(e.target.value)}
//                             displayEmpty IconComponent={KeyboardArrowDown}
//                             renderValue={(val) => val || (
//                                 <Typography sx={{ fontSize: 13, color: T2 }}>Select a document type…</Typography>
//                             )}
//                             sx={{
//                                 bgcolor: BG, borderRadius: "8px", fontSize: 13,
//                                 "& .MuiOutlinedInput-notchedOutline": { borderColor: BORDER },
//                                 "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: FB_MID },
//                                 "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: FB, borderWidth: 2 },
//                                 "& .MuiSelect-select": { py: 1.25, px: 1.5, fontSize: 13, fontWeight: 500, color: T1 },
//                             }}
//                             MenuProps={{
//                                 PaperProps: {
//                                     sx: {
//                                         borderRadius: "10px", mt: 0.5,
//                                         border: `0.5px solid ${BORDER}`,
//                                         boxShadow: "0 8px 24px rgba(24,119,242,0.10)",
//                                     }
//                                 }
//                             }}
//                         >
//                             {documentTypes.map((type) => (
//                                 <MenuItem key={type} value={type}
//                                     sx={{
//                                         fontSize: 13, fontWeight: 500, color: T1, py: 1.25, px: 2, gap: 1.5,
//                                         "&:hover": { bgcolor: FB_LIGHT },
//                                         "&.Mui-selected": { bgcolor: FB_LIGHT, color: FB },
//                                         "&.Mui-selected:hover": { bgcolor: FB_LIGHT },
//                                     }}
//                                 >
//                                     <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: FB, flexShrink: 0 }} />
//                                     {type}
//                                     {MULTI_SERIES_TYPES.includes(type) && (
//                                         <Chip
//                                             label="Multi-series"
//                                             size="small"
//                                             sx={{
//                                                 ml: "auto", fontSize: 10, height: 20,
//                                                 bgcolor: FB_LIGHT, color: FB,
//                                                 border: `0.5px solid ${FB_MID}`,
//                                             }}
//                                         />
//                                     )}
//                                 </MenuItem>
//                             ))}
//                         </Select>
//                     </FormControl>
//                 </Box>

//                 {/* ── Step 1.5 — Series selector ── */}
//                 {isMultiSeriesType && selectedType && (
//                     <Fade in={isMultiSeriesType}>
//                         <Box sx={{ ...cardBaseSx, p: { xs: 1.5, sm: 2 }, mb: { xs: 1.5, sm: 2 } }}>
//                             <Typography sx={{
//                                 fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".4px", mb: 1,
//                                 display: "flex", alignItems: "center", gap: "6px"
//                             }}>
//                                 <Box component="span" sx={{ width: 14, height: 14, bgcolor: FB, borderRadius: "4px", display: "inline-block" }} />
//                                 Step 2 — Select series
//                                 <Chip
//                                     label="Multi-series document"
//                                     size="small"
//                                     sx={{
//                                         ml: 1, fontSize: 10, height: 20,
//                                         bgcolor: FB_LIGHT, color: FB,
//                                         border: `0.5px solid ${FB_MID}`,
//                                     }}
//                                 />
//                             </Typography>
//                             <Typography sx={{ fontSize: 13, color: T2, mb: 1.5 }}>
//                                 This document type supports multiple series. Select a series to set its format individually.
//                             </Typography>

//                             {loadingSeries ? (
//                                 <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", py: 4, gap: 1.5 }}>
//                                     <CircularProgress size={24} sx={{ color: FB }} />
//                                     <Typography sx={{ fontSize: 13, color: T2 }}>Loading series…</Typography>
//                                 </Box>
//                             ) : seriesList.length > 0 ? (
//                                 <Grid container spacing={{ xs: 1, sm: 1.5 }}>
//                                     {seriesList.map((series, index) => {
//                                         const sId = getSeriesId(series);
//                                         const isSelected = selectedSeries && getSeriesId(selectedSeries) === sId;
//                                         const sAppliedFormat = seriesFormats[sId] || null;
//                                         return (
//                                             <Grid item key={sId} xs={12} sm={6} md={4}>
//                                                 <SeriesCard
//                                                     series={series}
//                                                     isSelected={isSelected}
//                                                     appliedFormat={sAppliedFormat}
//                                                     onClick={handleSelectSeries}
//                                                     index={index}
//                                                 />
//                                             </Grid>
//                                         );
//                                     })}
//                                 </Grid>
//                             ) : (
//                                 <Box sx={{
//                                     py: 4, textAlign: "center",
//                                     border: `1.5px dashed ${BORDER}`, borderRadius: "10px",
//                                 }}>
//                                     <Box sx={{
//                                         width: 44, height: 44, bgcolor: FB_LIGHT, borderRadius: "11px",
//                                         display: "flex", alignItems: "center", justifyContent: "center",
//                                         mx: "auto", mb: 1,
//                                     }}>
//                                         <BarChart sx={{ fontSize: 22, color: FB_MID }} />
//                                     </Box>
//                                     <Typography sx={{ fontSize: 14, fontWeight: 500, color: T1, mb: "4px" }}>
//                                         No series found
//                                     </Typography>
//                                     <Typography sx={{ fontSize: 12, color: T2 }}>
//                                         No series available for {selectedType}. Please create a series first.
//                                     </Typography>
//                                 </Box>
//                             )}

//                             {seriesList.length > 0 && Object.keys(seriesFormats).length > 0 && (
//                                 <Box sx={{
//                                     mt: 2, p: 1.5, bgcolor: BG, borderRadius: "8px",
//                                     border: `0.5px solid ${BORDER}`,
//                                 }}>
//                                     <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: 1, letterSpacing: ".3px" }}>
//                                         FORMAT SUMMARY
//                                     </Typography>
//                                     <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                                         {seriesList.map((series) => {
//                                             const sId = getSeriesId(series);
//                                             const sName = series?.SeriesName || series?.seriesName || series?.Name || series?.name || `Series ${sId}`;
//                                             const fmt = seriesFormats[sId];
//                                             return (
//                                                 <Chip
//                                                     key={sId}
//                                                     icon={fmt ? <CheckCircle sx={{ fontSize: 12, color: `${GREEN} !important` }} /> : undefined}
//                                                     label={`${sName}: ${fmt ? `Format ${fmt}` : 'Not set'}`}
//                                                     size="small"
//                                                     sx={{
//                                                         fontSize: 11, height: 24,
//                                                         bgcolor: fmt ? GREEN_LT : "#fff",
//                                                         color: fmt ? GREEN : T2,
//                                                         border: `0.5px solid ${fmt ? GREEN + '44' : BORDER}`,
//                                                         "& .MuiChip-icon": { ml: "6px" },
//                                                     }}
//                                                 />
//                                             );
//                                         })}
//                                     </Box>
//                                 </Box>
//                             )}
//                         </Box>
//                     </Fade>
//                 )}

//                 {/* ── Step 2/3 — Format grid ── */}
//                 {showFormatGrid ? (
//                     <Fade in={showFormatGrid}>
//                         <Box>
//                             <Box sx={{
//                                 ...cardBaseSx, px: { xs: 1.5, sm: 2 }, py: 1.5,
//                                 mb: { xs: 1.5, sm: 2 },
//                                 display: "flex", alignItems: "center", justifyContent: "space-between",
//                                 flexWrap: "wrap", gap: 1
//                             }}>
//                                 <Box>
//                                     <Typography sx={{
//                                         fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".4px", mb: "2px",
//                                         display: "flex", alignItems: "center", gap: "6px"
//                                     }}>
//                                         <Box component="span" sx={{ width: 14, height: 14, bgcolor: FB, borderRadius: "4px", display: "inline-block" }} />
//                                         Step {isMultiSeriesType ? '3' : '2'} — Choose format
//                                     </Typography>
//                                     <Typography sx={{ fontSize: 15, fontWeight: 500, color: T1 }}>
//                                         {selectedType} templates
//                                         {isMultiSeriesType && selectedSeries && (
//                                             <Box component="span" sx={{
//                                                 ml: 1, fontSize: 12, color: FB, fontWeight: 500,
//                                                 px: "8px", py: "2px", bgcolor: FB_LIGHT, borderRadius: "12px",
//                                                 border: `0.5px solid ${FB_MID}`,
//                                             }}>
//                                                 {selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || selectedSeries?.name || 'Selected Series'}
//                                             </Box>
//                                         )}
//                                         <Box component="span" sx={{ ml: 1, fontSize: 12, color: T2, fontWeight: 400 }}>
//                                             ({FORMAT_COUNT} available)
//                                         </Box>
//                                     </Typography>
//                                 </Box>
//                                 {appliedFormat && (
//                                     <Box sx={{
//                                         display: "inline-flex", alignItems: "center", gap: "6px",
//                                         px: "10px", py: "4px", bgcolor: GREEN_LT, borderRadius: "20px",
//                                         border: `0.5px solid ${GREEN}44`
//                                     }}>
//                                         <CheckCircle sx={{ fontSize: 13, color: GREEN }} />
//                                         <Typography sx={{ fontSize: 12, fontWeight: 500, color: GREEN }}>
//                                             Format {appliedFormat} is active
//                                             {isMultiSeriesType && selectedSeries && (
//                                                 <Box component="span" sx={{ ml: 0.5, fontSize: 11, color: GREEN, opacity: 0.8 }}>
//                                                     for this series
//                                                 </Box>
//                                             )}
//                                         </Typography>
//                                     </Box>
//                                 )}
//                             </Box>

//                             <Grid container spacing={{ xs: 1.25, sm: 2 }}>
//                                 {formats.map((format) => (
//                                     <Grid item key={format} xs={6} sm={4} md={3}>
//                                         <FormatCard
//                                             format={format}
//                                             selectedType={selectedType}
//                                             isApplied={appliedFormat === format}
//                                             onClick={() => handleCardClick(format)}
//                                         />
//                                     </Grid>
//                                 ))}
//                             </Grid>
//                         </Box>
//                     </Fade>
//                 ) : !selectedType ? (
//                     <Box sx={{
//                         ...cardBaseSx, py: { xs: 6, sm: 8 }, textAlign: "center",
//                         border: `1.5px dashed ${BORDER}`,
//                     }}>
//                         <Box sx={{
//                             width: 52, height: 52, bgcolor: FB_LIGHT, borderRadius: "13px",
//                             display: "flex", alignItems: "center", justifyContent: "center",
//                             mx: "auto", mb: 1.5,
//                         }}>
//                             <FilePresent sx={{ fontSize: 26, color: FB_MID }} />
//                         </Box>
//                         <Typography sx={{ fontSize: 15, fontWeight: 500, color: T1, mb: "4px" }}>
//                             No document type selected
//                         </Typography>
//                         <Typography sx={{ fontSize: 13, color: T2 }}>
//                             Select a type above to browse {FORMAT_COUNT} professional templates
//                         </Typography>
//                     </Box>
//                 ) : isMultiSeriesType && !selectedSeries ? (
//                     !loadingSeries && seriesList.length > 0 && (
//                         <Box sx={{
//                             ...cardBaseSx, py: { xs: 5, sm: 6 }, textAlign: "center",
//                             border: `1.5px dashed ${BORDER}`,
//                         }}>
//                             <Box sx={{
//                                 width: 52, height: 52, bgcolor: FB_LIGHT, borderRadius: "13px",
//                                 display: "flex", alignItems: "center", justifyContent: "center",
//                                 mx: "auto", mb: 1.5,
//                             }}>
//                                 <BarChart sx={{ fontSize: 26, color: FB_MID }} />
//                             </Box>
//                             <Typography sx={{ fontSize: 15, fontWeight: 500, color: T1, mb: "4px" }}>
//                                 Select a series to continue
//                             </Typography>
//                             <Typography sx={{ fontSize: 13, color: T2 }}>
//                                 Choose a series from above to set its template format
//                             </Typography>
//                         </Box>
//                     )
//                 ) : null}
//             </Box>

//             {/* ── Preview dialog ── */}
//             <PreviewDialog
//                 open={previewOpen}
//                 onClose={() => { setPreviewOpen(false); setSelectedFormat(null); }}
//                 selectedType={selectedType}
//                 selectedFormat={selectedFormat}
//                 appliedFormat={appliedFormat}
//                 onApply={handleApplyTemplate}
//                 selectedSeries={selectedSeries}
//             />

//             {/* ── Snackbar ── */}
//             <Snackbar open={snack.open} autoHideDuration={3000}
//                 onClose={() => setSnack(s => ({ ...s, open: false }))}
//                 anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//             >
//                 <Alert severity={snack.severity} variant="filled"
//                     onClose={() => setSnack(s => ({ ...s, open: false }))}
//                     sx={{ borderRadius: "8px", fontWeight: 500 }}
//                 >
//                     {snack.msg}
//                 </Alert>
//             </Snackbar>
//         </Box>
//     );
// }







// import React, { useRef, useState, useEffect, useCallback } from 'react';
// import axios from 'axios';
// import { useAuth } from '../context/AuthContext';
// import {
//     Box, Typography, Grid, Card, CardMedia, CardContent, Chip, MenuItem, Select,
//     FormControl, Dialog, DialogContent, Button, IconButton, Snackbar, Alert, Fade,
//     Zoom, Skeleton, Tooltip, useTheme, useMediaQuery, CircularProgress
// } from '@mui/material';
// import {
//     CheckCircle, Close, ZoomIn, ZoomOut, OpenInFull, FilePresent, KeyboardArrowDown,
//     AutoAwesome, BarChart
// } from '@mui/icons-material';

// // ─── DESIGN TOKENS ────────────────────────────────────────────────────────────
// const FB = "#1877F2";
// const FB_DARK = "#0C5FD6";
// const FB_LIGHT = "#E7F0FD";
// const FB_MID = "#B3CFF9";
// const BG = "#F0F4FF";
// const BORDER = "#DCE3F5";
// const T1 = "#0F1B35";
// const T2 = "#5A6A8A";
// const GREEN = "#1a9e5c";
// const GREEN_LT = "#e6f7ef";
// const RED = "#E24B4A";

// // ─── CONSTANTS ────────────────────────────────────────────────────────────────
// const publicUrl = typeof process !== 'undefined' && process.env?.PUBLIC_URL ? process.env.PUBLIC_URL : '';
// const dummyImg = `${publicUrl}/Quotation_Image.jpeg`;

// // ✅ NEW: Format configuration for different document types
// const FORMAT_CONFIG = {
//     'Quotation': 10,
//     'Proforma Invoice': 10,
//     'Sale Challan': 13,
//     'Sale Invoice': 10,
//     'Purchase Order': 10,
//     'Purchase Dispatch': 13,
//     'Purchase Invoice': 10,
//     'Credit Note': 10,
//     'Debit Note': 10,
// };

// // ✅ NEW: Get format count for any document type
// const getFormatCount = (type) => {
//     return FORMAT_CONFIG[type] || 10;
// };

// const getImageForTypeFormat = (type = '', format = 0) => {
//     const idx = Number(format) || 0;
//     if (!idx || idx < 1 || idx > 20) return { thumb: dummyImg, large: dummyImg };
//     const norm = (type || '').replace(/\s+/g, '').toLowerCase();
//     const build = (base) => `${publicUrl}/${base}${idx}.jpg`;
//     const map = {
//         quotation: () => build('Quotation'),
//         saleorder: () => build('SaleOrder'),
//         proformainvoice: () => build('ProformaInvoice'),
//         salechallan: () => build('SaleChallan'),
//         saleinvoice: () => build('SaleInvoice'),
//         creditnote: () => build('CreditNote'),
//         purchaseorder: () => build('PurchaseOrder'),
//         purchasedispatch: () => build('PurchaseChallan'),
//         purchaseinvoice: () => build('PurchaseInvoice'),
//         debitnote: () => build('DebitNote'),
//     };
//     const src = map[norm] ? map[norm]() : dummyImg;
//     return { thumb: src, large: src };
// };

// const documentTypes = [
//     'Quotation',
//     'Proforma Invoice',
//     'Sale Challan',
//     'Sale Invoice',
// ];

// // Document types that support multiple series
// const MULTI_SERIES_TYPES = ['Sale Challan', 'Sale Invoice', 'Proforma Invoice', 'Credit Note'];

// const FORMAT_COUNT = 10;
// const formats = Array.from({ length: FORMAT_COUNT }, (_, i) => i + 1);

// // ─── SHARED SX ────────────────────────────────────────────────────────────────
// const cardBaseSx = {
//     background: "#fff", border: `0.5px solid ${BORDER}`, borderRadius: "12px",
// };

// const btnPrimarySx = {
//     background: FB, color: "#fff", borderRadius: "8px", fontSize: 13, fontWeight: 500,
//     textTransform: "none", px: 2.5, height: 38,
//     "&:hover": { background: FB_DARK },
//     "&:disabled": { background: FB_MID, color: "#fff" },
// };

// const btnGhostSx = {
//     background: "transparent", color: T2, border: `0.5px solid ${BORDER}`, borderRadius: "8px",
//     fontSize: 13, fontWeight: 500, textTransform: "none", px: 2.5, height: 38,
//     "&:hover": { background: "#fff", color: T1 },
// };

// // ─── SERIES CARD ──────────────────────────────────────────────────────────────
// function SeriesCard({ series, isSelected, appliedFormat, onClick, index }) {
//     const seriesName = series?.SeriesName || series?.seriesName || series?.Name || series?.name || `Series ${series?.SeriesId || series?.SeriesID || index + 1}`;
//     const seriesId = series?.SeriesId || series?.SeriesID || series?.seriesId || series?.Id || series?.id || index + 1;

//     return (
//         <Zoom in style={{ transitionDelay: `${index * 40}ms` }}>
//             <Card
//                 onClick={() => onClick(series)}
//                 sx={{
//                     cursor: "pointer", borderRadius: "12px", overflow: "hidden",
//                     border: isSelected ? `2px solid ${FB}` : `0.5px solid ${BORDER}`,
//                     outline: isSelected ? `4px solid ${FB_LIGHT}` : "none",
//                     boxShadow: "none", transition: "all 0.2s ease",
//                     "&:hover": {
//                         boxShadow: `0 6px 24px rgba(24,119,242,0.14)`,
//                         transform: "translateY(-4px)", borderColor: FB,
//                     },
//                     background: "#fff", p: 2,
//                 }}
//             >
//                 <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//                         <Box sx={{
//                             width: 40, height: 40, borderRadius: "10px",
//                             bgcolor: isSelected ? FB : FB_LIGHT,
//                             display: "flex", alignItems: "center", justifyContent: "center",
//                             transition: "all 0.2s ease",
//                         }}>
//                             <BarChart sx={{ fontSize: 20, color: isSelected ? "#fff" : FB }} />
//                         </Box>
//                         <Box>
//                             <Typography sx={{ fontSize: 14, fontWeight: 500, color: T1, lineHeight: 1.3 }}>
//                                 {seriesName}
//                             </Typography>
//                             <Typography sx={{ fontSize: 11, color: T2 }}>
//                                 Series ID: {seriesId}
//                             </Typography>
//                         </Box>
//                     </Box>
//                     <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                         {appliedFormat && (
//                             <Chip
//                                 icon={<CheckCircle sx={{ fontSize: 13, color: `${GREEN} !important` }} />}
//                                 label={`Format ${appliedFormat}`}
//                                 size="small"
//                                 sx={{
//                                     fontSize: 11, fontWeight: 500, height: 24,
//                                     bgcolor: GREEN_LT, color: GREEN,
//                                     border: `0.5px solid ${GREEN}44`,
//                                     "& .MuiChip-icon": { ml: "6px" },
//                                 }}
//                             />
//                         )}
//                         {isSelected && (
//                             <Box sx={{
//                                 width: 24, height: 24, borderRadius: "50%", bgcolor: FB,
//                                 display: "flex", alignItems: "center", justifyContent: "center",
//                             }}>
//                                 <CheckCircle sx={{ color: "#fff", fontSize: 16 }} />
//                             </Box>
//                         )}
//                     </Box>
//                 </Box>
//             </Card>
//         </Zoom>
//     );
// }

// // ─── FORMAT CARD ──────────────────────────────────────────────────────────────
// function FormatCard({ format, selectedType, isApplied, onClick }) {
//     const [imgLoaded, setImgLoaded] = useState(false);
//     const { thumb } = getImageForTypeFormat(selectedType, format);

//     return (
//         <Zoom in style={{ transitionDelay: `${(format - 1) * 40}ms` }}>
//             <Card
//                 onClick={onClick}
//                 sx={{
//                     cursor: "pointer", borderRadius: "12px", overflow: "hidden",
//                     border: isApplied ? `2px solid ${FB}` : `0.5px solid ${BORDER}`,
//                     outline: isApplied ? `4px solid ${FB_LIGHT}` : "none",
//                     boxShadow: "none", transition: "all 0.2s ease",
//                     "&:hover": {
//                         boxShadow: `0 6px 24px rgba(24,119,242,0.14)`,
//                         transform: "translateY(-4px)", borderColor: FB,
//                     },
//                     position: "relative", background: "#fff",
//                 }}
//             >
//                 <Box sx={{ position: "relative", bgcolor: BG, height: { xs: 160, sm: 200, md: 220 }, overflow: "hidden" }}>
//                     {!imgLoaded && (
//                         <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" sx={{ bgcolor: FB_LIGHT }} />
//                     )}
//                     <CardMedia component="img" image={thumb} alt={`Format ${format}`}
//                         onLoad={() => setImgLoaded(true)}
//                         onError={(e) => { e.currentTarget.src = dummyImg; setImgLoaded(true); }}
//                         sx={{
//                             height: "100%", objectFit: "cover",
//                             display: imgLoaded ? "block" : "none",
//                             transition: "transform 0.3s ease",
//                             "&:hover": { transform: "scale(1.04)" },
//                         }}
//                     />
//                     <Box sx={{
//                         position: "absolute", inset: 0,
//                         background: "linear-gradient(to top, rgba(24,119,242,0.25) 0%, transparent 50%)",
//                         pointerEvents: "none",
//                     }} />
//                     <Box sx={{
//                         position: "absolute", top: 10, left: 10, px: "8px", py: "3px",
//                         background: isApplied ? FB : "rgba(255,255,255,0.9)",
//                         borderRadius: "6px", border: `0.5px solid ${isApplied ? FB : BORDER}`,
//                     }}>
//                         <Typography sx={{ fontSize: 11, fontWeight: 500, color: isApplied ? "#fff" : T2 }}>
//                             Format {format}
//                         </Typography>
//                     </Box>
//                     {isApplied && (
//                         <Box sx={{
//                             position: "absolute", top: 10, right: 10,
//                             width: 28, height: 28, borderRadius: "50%",
//                             bgcolor: GREEN, display: "flex",
//                             alignItems: "center", justifyContent: "center",
//                         }}>
//                             <CheckCircle sx={{ color: "#fff", fontSize: 18 }} />
//                         </Box>
//                     )}
//                 </Box>
//                 <CardContent sx={{ py: 1.25, px: 1.5, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
//                     <Typography sx={{ fontSize: 13, fontWeight: 500, color: T1 }}>
//                         Format {format}
//                     </Typography>
//                     {isApplied ? (
//                         <Chip
//                             icon={<CheckCircle sx={{ fontSize: 14, color: `${GREEN} !important` }} />}
//                             label="Active"
//                             size="small"
//                             sx={{
//                                 fontSize: 11, fontWeight: 500, height: 22,
//                                 bgcolor: GREEN_LT, color: GREEN,
//                                 border: `0.5px solid ${GREEN}44`,
//                                 "& .MuiChip-icon": { ml: "6px" },
//                             }}
//                         />
//                     ) : (
//                         <Chip
//                             label="Preview"
//                             size="small"
//                             sx={{
//                                 fontSize: 11, height: 22,
//                                 bgcolor: FB_LIGHT, color: FB,
//                                 border: `0.5px solid ${FB_MID}`,
//                             }}
//                         />
//                     )}
//                 </CardContent>
//             </Card>
//         </Zoom>
//     );
// }

// // ─── PREVIEW DIALOG ───────────────────────────────────────────────────────────
// function PreviewDialog({ open, onClose, selectedType, selectedFormat, onApply, appliedFormat, selectedSeries }) {

//     // ── All values stored in refs so event listeners always see latest values ──
//     const scaleRef = useRef(1);
//     const originRef = useRef({ x: 50, y: 50 });
//     const translateRef = useRef({ x: 0, y: 0 });
//     const isDraggingRef = useRef(false);
//     const dragStartRef = useRef({ mouseX: 0, mouseY: 0, translateX: 0, translateY: 0 });

//     // ── React state only for triggering re-renders ──
//     const [scale, setScale] = useState(1);
//     const [origin, setOrigin] = useState({ x: 50, y: 50 });
//     const [translate, setTranslate] = useState({ x: 0, y: 0 });
//     const [isDragging, setIsDragging] = useState(false);

//     const containerRef = useRef(null);

//     const { large } = getImageForTypeFormat(selectedType, selectedFormat);
//     const isAlreadyApplied = appliedFormat === selectedFormat;
//     const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'));
//     const isMultiSeries = MULTI_SERIES_TYPES.includes(selectedType);
//     const seriesName = selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || selectedSeries?.name || '';

//     // ── Master reset ──────────────────────────────────────────────────────────
//     const resetAll = useCallback(() => {
//         scaleRef.current = 1;
//         originRef.current = { x: 50, y: 50 };
//         translateRef.current = { x: 0, y: 0 };
//         isDraggingRef.current = false;
//         setScale(1);
//         setOrigin({ x: 50, y: 50 });
//         setTranslate({ x: 0, y: 0 });
//         setIsDragging(false);
//     }, []);

//     // ── Reset when dialog closes ──────────────────────────────────────────────
//     useEffect(() => {
//         if (!open) resetAll();
//     }, [open, resetAll]);

//     // ── Get pointer position as % inside the container ────────────────────────
//     const getPointerOrigin = useCallback((clientX, clientY) => {
//         const container = containerRef.current;
//         if (!container) return { x: 50, y: 50 };
//         const rect = container.getBoundingClientRect();
//         const x = Math.min(Math.max(((clientX - rect.left) / rect.width) * 100, 0), 100);
//         const y = Math.min(Math.max(((clientY - rect.top) / rect.height) * 100, 0), 100);
//         return { x, y };
//     }, []);

//     // ── Core zoom function — reads/writes refs, then syncs state ──────────────
//     const applyZoom = useCallback((delta, pointerOrigin) => {
//         const newScale = Math.min(Math.max(scaleRef.current * delta, 0.4), 5);
//         scaleRef.current = newScale;

//         if (pointerOrigin) {
//             originRef.current = pointerOrigin;
//             setOrigin({ ...pointerOrigin });
//         }

//         // Auto-reset translation when fully zoomed out
//         if (newScale <= 1) {
//             translateRef.current = { x: 0, y: 0 };
//             setTranslate({ x: 0, y: 0 });
//         }

//         setScale(newScale);
//     }, []);

//     // ── Wheel handler — defined with useCallback so it is stable ─────────────
//     const handleWheel = useCallback((e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         const po = getPointerOrigin(e.clientX, e.clientY);
//         const delta = e.deltaY > 0 ? 0.93 : 1.07;
//         applyZoom(delta, po);
//     }, [getPointerOrigin, applyZoom]);

//     // ── Attach wheel listener with { passive: false } on the container ────────
//     // Re-attach whenever handleWheel changes (it's stable, so this runs once per open)
//     useEffect(() => {
//         const el = containerRef.current;
//         if (!el || !open) return;
//         el.addEventListener('wheel', handleWheel, { passive: false });
//         return () => {
//             el.removeEventListener('wheel', handleWheel);
//         };
//     }, [open, handleWheel]);

//     // ── Button zoom — uses last known pointer origin ──────────────────────────
//     const handleZoomIn = useCallback(() => {
//         applyZoom(1.25, originRef.current);
//     }, [applyZoom]);

//     const handleZoomOut = useCallback(() => {
//         applyZoom(0.8, originRef.current);
//     }, [applyZoom]);

//     const handleReset = useCallback(() => {
//         resetAll();
//     }, [resetAll]);

//     // ── Mouse move — track pointer for button-zoom aim + handle drag ──────────
//     const handleMouseMove = useCallback((e) => {
//         if (!isDraggingRef.current) {
//             // Keep origin ref updated so button zooms aim at cursor
//             originRef.current = getPointerOrigin(e.clientX, e.clientY);
//             return;
//         }
//         // While dragging compute new translation
//         const dx = e.clientX - dragStartRef.current.mouseX;
//         const dy = e.clientY - dragStartRef.current.mouseY;
//         const newTranslate = {
//             x: dragStartRef.current.translateX + dx,
//             y: dragStartRef.current.translateY + dy,
//         };
//         translateRef.current = newTranslate;
//         setTranslate({ ...newTranslate });
//     }, [getPointerOrigin]);

//     // ── Mouse down — begin drag only when zoomed in ───────────────────────────
//     const handleMouseDown = useCallback((e) => {
//         if (scaleRef.current <= 1) return;
//         e.preventDefault();
//         isDraggingRef.current = true;
//         setIsDragging(true);
//         dragStartRef.current = {
//             mouseX: e.clientX,
//             mouseY: e.clientY,
//             translateX: translateRef.current.x,
//             translateY: translateRef.current.y,
//         };
//     }, []);

//     // ── Mouse up — stop drag the instant button is released ──────────────────
//     const handleMouseUp = useCallback(() => {
//         if (!isDraggingRef.current) return;
//         isDraggingRef.current = false;
//         setIsDragging(false);
//     }, []);

//     // ── Mouse leave — stop drag so image never gets stuck ────────────────────
//     const handleMouseLeave = useCallback(() => {
//         if (!isDraggingRef.current) return;
//         isDraggingRef.current = false;
//         setIsDragging(false);
//     }, []);

//     // ── Touch handlers (mobile) ───────────────────────────────────────────────
//     const handleTouchStart = useCallback((e) => {
//         if (scaleRef.current <= 1 || e.touches.length !== 1) return;
//         const touch = e.touches[0];
//         isDraggingRef.current = true;
//         setIsDragging(true);
//         dragStartRef.current = {
//             mouseX: touch.clientX,
//             mouseY: touch.clientY,
//             translateX: translateRef.current.x,
//             translateY: translateRef.current.y,
//         };
//     }, []);

//     const handleTouchMove = useCallback((e) => {
//         if (!isDraggingRef.current || e.touches.length !== 1) return;
//         e.preventDefault();
//         const touch = e.touches[0];
//         const dx = touch.clientX - dragStartRef.current.mouseX;
//         const dy = touch.clientY - dragStartRef.current.mouseY;
//         const newTranslate = {
//             x: dragStartRef.current.translateX + dx,
//             y: dragStartRef.current.translateY + dy,
//         };
//         translateRef.current = newTranslate;
//         setTranslate({ ...newTranslate });
//     }, []);

//     const handleTouchEnd = useCallback(() => {
//         isDraggingRef.current = false;
//         setIsDragging(false);
//     }, []);

//     // ── Attach touchmove with { passive: false } so preventDefault works ──────
//     useEffect(() => {
//         const el = containerRef.current;
//         if (!el || !open) return;
//         el.addEventListener('touchmove', handleTouchMove, { passive: false });
//         return () => {
//             el.removeEventListener('touchmove', handleTouchMove);
//         };
//     }, [open, handleTouchMove]);

//     // ─────────────────────────────────────────────────────────────────────────
//     return (
//         <Dialog
//             open={open}
//             onClose={onClose}
//             maxWidth="md"
//             fullWidth
//             fullScreen={isMobile}
//             TransitionComponent={Fade}
//             PaperProps={{
//                 sx: {
//                     borderRadius: isMobile ? 0 : "14px",
//                     overflow: "hidden",
//                     maxHeight: isMobile ? "100vh" : "92vh",
//                     border: `0.5px solid ${BORDER}`,
//                 }
//             }}
//         >
//             {/* ── Header ── */}
//             <Box sx={{
//                 display: "flex", alignItems: "center", justifyContent: "space-between",
//                 px: { xs: 2, sm: 3 }, py: 1.75,
//                 background: FB, color: "#fff",
//                 borderBottom: `1.5px solid ${FB_DARK}`,
//             }}>
//                 <Box>
//                     <Typography sx={{ fontSize: 15, fontWeight: 500, color: "#fff" }}>
//                         {selectedType}
//                         {isMultiSeries && seriesName && (
//                             <Box component="span" sx={{ ml: 1, fontSize: 12, color: "rgba(255,255,255,0.75)" }}>
//                                 — {seriesName}
//                             </Box>
//                         )}
//                     </Typography>
//                     <Typography sx={{ fontSize: 12, color: "rgba(255,255,255,0.7)" }}>
//                         Format {selectedFormat}
//                     </Typography>
//                 </Box>
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//                     <Tooltip title="Zoom out">
//                         <IconButton size="small" sx={{ color: "#fff" }} onClick={handleZoomOut}>
//                             <ZoomOut sx={{ fontSize: 18 }} />
//                         </IconButton>
//                     </Tooltip>
//                     <Box sx={{
//                         px: "8px", py: "3px", bgcolor: "rgba(255,255,255,0.15)",
//                         borderRadius: "6px", mx: 0.5,
//                     }}>
//                         <Typography sx={{ fontSize: 12, fontWeight: 500, color: "#fff", minWidth: 40, textAlign: "center" }}>
//                             {Math.round(scale * 100)}%
//                         </Typography>
//                     </Box>
//                     <Tooltip title="Zoom in">
//                         <IconButton size="small" sx={{ color: "#fff" }} onClick={handleZoomIn}>
//                             <ZoomIn sx={{ fontSize: 18 }} />
//                         </IconButton>
//                     </Tooltip>
//                     <Tooltip title="Reset">
//                         <IconButton size="small" sx={{ color: "#fff" }} onClick={handleReset}>
//                             <OpenInFull sx={{ fontSize: 16 }} />
//                         </IconButton>
//                     </Tooltip>
//                     <IconButton size="small" sx={{ color: "#fff", ml: 0.5 }} onClick={onClose}>
//                         <Close sx={{ fontSize: 18 }} />
//                     </IconButton>
//                 </Box>
//             </Box>

//             {/* ── Image / drag area ── */}
//             <DialogContent
//                 ref={containerRef}
//                 sx={{
//                     p: 0,
//                     bgcolor: BG,
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     minHeight: isMobile ? "calc(100vh - 140px)" : 400,
//                     overflow: "hidden",
//                     cursor: isDragging ? "grabbing" : scale > 1 ? "grab" : "zoom-in",
//                     position: "relative",
//                     userSelect: "none",
//                 }}
//                 onMouseMove={handleMouseMove}
//                 onMouseDown={handleMouseDown}
//                 onMouseUp={handleMouseUp}
//                 onMouseLeave={handleMouseLeave}
//                 onTouchStart={handleTouchStart}
//                 onTouchEnd={handleTouchEnd}
//             >
//                 <Box
//                     sx={{
//                         // No transition while dragging for instant response
//                         transition: isDragging ? "none" : "transform 0.12s ease",
//                         transform: `translate(${translate.x}px, ${translate.y}px) scale(${scale})`,
//                         transformOrigin: `${origin.x}% ${origin.y}%`,
//                         display: "inline-block",
//                         lineHeight: 0,
//                         // Prevent the inner box from catching pointer events
//                         pointerEvents: "none",
//                     }}
//                 >
//                     <img
//                         src={large}
//                         alt="Preview"
//                         draggable={false}
//                         onError={(e) => { e.currentTarget.src = dummyImg; }}
//                         style={{
//                             maxWidth: "100%",
//                             maxHeight: isMobile ? "70vh" : "60vh",
//                             objectFit: "contain",
//                             display: "block",
//                             userSelect: "none",
//                             pointerEvents: "none",
//                         }}
//                     />
//                 </Box>
//             </DialogContent>

//             {/* ── Footer ── */}
//             <Box sx={{
//                 px: { xs: 2, sm: 3 }, py: 2,
//                 display: "flex", gap: 1.5, justifyContent: "flex-end",
//                 borderTop: `0.5px solid ${BORDER}`, bgcolor: "#fff",
//                 flexWrap: "wrap",
//             }}>
//                 <Button onClick={onClose} sx={btnGhostSx}>Cancel</Button>
//                 <Button
//                     onClick={onApply}
//                     disabled={isAlreadyApplied}
//                     startIcon={isAlreadyApplied
//                         ? <CheckCircle sx={{ fontSize: 16 }} />
//                         : <AutoAwesome sx={{ fontSize: 16 }} />}
//                     sx={{
//                         ...btnPrimarySx,
//                         ...(isAlreadyApplied && {
//                             bgcolor: GREEN_LT, color: GREEN,
//                             border: `0.5px solid ${GREEN}44`,
//                             "&:disabled": { bgcolor: GREEN_LT, color: GREEN }
//                         }),
//                     }}
//                 >
//                     {isAlreadyApplied ? "Currently active" : "Apply template"}
//                 </Button>
//             </Box>
//         </Dialog>
//     );
// }

// // ─── MAIN ─────────────────────────────────────────────────────────────────────
// export default function FormatSelectionScreen({ loggedInUser, companyData, connectionString }) {
//     const API = connectionString;
//     const auth = useAuth();
//     const { selectedCompany } = useAuth();
//     const authSelectedCompany = auth?.selectedCompany ?? null;
//     const muiTheme = useTheme();
//     const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
//     const isTablet = useMediaQuery(muiTheme.breakpoints.down('md'));

//     const [selectedType, setSelectedType] = useState('');
//     const [selectedFormat, setSelectedFormat] = useState(null);
//     const [appliedFormat, setAppliedFormat] = useState(null);
//     const [previewOpen, setPreviewOpen] = useState(false);
//     const [snack, setSnack] = useState({ open: false, msg: '', severity: 'success' });

//     // ✅ NEW: State to track current format count
//     const [currentFormatCount, setCurrentFormatCount] = useState(FORMAT_COUNT);

//     // Multi-series states
//     const [seriesList, setSeriesList] = useState([]);
//     const [selectedSeries, setSelectedSeries] = useState(null);
//     const [seriesFormats, setSeriesFormats] = useState({});
//     const [loadingSeries, setLoadingSeries] = useState(false);

//     const AppRegID = selectedCompany?.AppRegID || null;
//     const isMultiSeriesType = MULTI_SERIES_TYPES.includes(selectedType);

//     // ── Company resolution ────────────────────────────────────────────────────
//     const companyFromProp = Array.isArray(companyData) ? companyData[0] : (companyData || null);
//     let fallbackLS = null;
//     try {
//         const s = typeof window !== 'undefined' ? window.localStorage.getItem('selectedCompany') : null;
//         if (s) fallbackLS = JSON.parse(s);
//     } catch { fallbackLS = null; }

//     const companyObj = authSelectedCompany || companyFromProp
//         || (loggedInUser && (loggedInUser.selectedCompany || loggedInUser.company || loggedInUser.companyData))
//         || fallbackLS || {};

//     const tryNum = (v) => { if (v == null || v === '') return 0; const n = Number(v); return isFinite(n) ? n : 0; };
//     const GCompId_RAW = companyObj?.GCompId ?? companyObj?.GCompid ?? companyObj?.GCompID ?? null;
//     const GCompId = (GCompId_RAW == null || GCompId_RAW === '') ? null : tryNum(GCompId_RAW);

//     let CompId = 0;
//     for (const c of [companyObj?.CompId, companyObj?.CompID, companyObj?.Compid, companyObj?.CompanyId, loggedInUser?.CompId, loggedInUser?.CompanyId]) {
//         const n = tryNum(c);
//         if (n > 0) { CompId = n; break; }
//     }
//     if (!CompId && fallbackLS) {
//         for (const c of [fallbackLS?.CompId, fallbackLS?.CompID, fallbackLS?.CompanyId]) {
//             const n = tryNum(c);
//             if (n > 0) { CompId = n; break; }
//         }
//     }

//     const CURRENT_USER_ID = Number(loggedInUser?.UserId ?? loggedInUser?.UserID ?? 0);
//     const toMySqlDT = (d) => {
//         const p = (n) => String(n).padStart(2, '0');
//         return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
//     };

//     const getBookNameKey = (type, series = null) => {
//         const base = type.replace(/\s+/g, '');
//         if (series) {
//             const seriesId = series?.SeriesId || series?.SeriesID || series?.seriesId || series?.Id || series?.id || 0;
//             return `${base}_Series_${seriesId}`;
//         }
//         return base;
//     };

//     const getSeriesId = (series) => {
//         return series?.SeriesId || series?.SeriesID || series?.seriesId || series?.Id || series?.id || 0;
//     };

//     // ── Fetch series ──────────────────────────────────────────────────────────
//     const fetchSeriesForType = async (type) => {
//         setLoadingSeries(true);
//         setSeriesList([]);
//         setSelectedSeries(null);
//         setSeriesFormats({});
//         try {
//             const companyIdParam = CompId || 0;
//             const typeNorm = type.replace(/\s+/g, '');
//             const resp = await axios.get(`${API}/api/seriesForPDF`, {
//                 params: { companyId: companyIdParam, documentType: typeNorm },
//                 timeout: 15000,
//             });

//             let arr = [];
//             if (resp?.data) {
//                 if (Array.isArray(resp.data.series)) arr = resp.data.series;
//                 else if (Array.isArray(resp.data)) arr = resp.data;
//                 else if (Array.isArray(resp.data.data)) arr = resp.data.data;
//             }
//             setSeriesList(arr);

//             if (arr.length > 0) {
//                 try {
//                     const fmtResp = await axios.get(`${API}/api/companies`, {
//                         params: { companyId: companyIdParam },
//                         timeout: 15000,
//                     });
//                     let companies = [];
//                     if (fmtResp?.data) {
//                         if (Array.isArray(fmtResp.data.companies)) companies = fmtResp.data.companies;
//                         else if (Array.isArray(fmtResp.data)) companies = fmtResp.data;
//                         else if (Array.isArray(fmtResp.data.data)) companies = fmtResp.data.data;
//                     }
//                     const wantedId = Number(CompId || companyIdParam || 0);
//                     const rec = companies.find(c => tryNum(c?.CompId ?? c?.CompID ?? 0) === wantedId) || companies[0];
//                     if (rec && Array.isArray(rec.formats)) {
//                         const norm = (s) => String(s || '').replace(/\s+/g, '').toLowerCase();
//                         const fmtMap = {};
//                         for (const series of arr) {
//                             const sId = getSeriesId(series);
//                             const wantedBookName = norm(typeNorm);
//                             for (const f of rec.formats) {
//                                 const bName = norm(f?.BookName ?? '');
//                                 const bId = Number(f?.BookID ?? f?.BookId ?? 0);
//                                 const fSeriesId = Number(f?.SeriesId ?? f?.seriesId ?? 0);
//                                 if (bId && bName === wantedBookName && fSeriesId === Number(sId)) {
//                                     fmtMap[sId] = bId;
//                                     break;
//                                 }
//                             }
//                             if (!fmtMap[sId]) {
//                                 for (const f of rec.formats) {
//                                     const bName = norm(f?.BookName ?? '');
//                                     const bId = Number(f?.BookID ?? f?.BookId ?? 0);
//                                     const fSeriesId = Number(f?.SeriesId ?? f?.seriesId ?? 0);
//                                     if (bId && bName === wantedBookName && (!fSeriesId || fSeriesId === 0)) {
//                                         fmtMap[sId] = bId;
//                                         break;
//                                     }
//                                 }
//                             }
//                         }
//                         setSeriesFormats(fmtMap);
//                     }
//                 } catch (err) {
//                     console.warn('Error fetching series formats', err?.message);
//                 }
//             }
//         } catch (err) {
//             console.warn('Series API error', err?.response?.data || err?.message);
//             setSeriesList([]);
//             setSelectedSeries(null);
//             setSeriesFormats({});
//             setSnack({ open: true, msg: err?.response?.data?.message || 'Failed to load series.', severity: 'error' });
//         } finally {
//             setLoadingSeries(false);
//         }
//     };

//     // ── Handlers ─────────────────────────────────────────────────────────────
//     const handleSelectType = async (type) => {
//         // ✅ NEW: Update format count based on selected type
//         const formatCount = getFormatCount(type);
//         setCurrentFormatCount(formatCount);

//         setSelectedType(type);
//         setSelectedFormat(null);
//         setAppliedFormat(null);
//         setSelectedSeries(null);
//         setSeriesList([]);
//         setSeriesFormats({});

//         if (MULTI_SERIES_TYPES.includes(type)) {
//             await fetchSeriesForType(type);
//         } else {
//             try {
//                 const companyIdParam = CompId || 0;
//                 const resp = await axios.get(`${API}/api/companies`, { params: { companyId: companyIdParam }, timeout: 15000 });
//                 let arr = [];
//                 if (resp?.data) {
//                     if (Array.isArray(resp.data.companies)) arr = resp.data.companies;
//                     else if (Array.isArray(resp.data)) arr = resp.data;
//                     else if (Array.isArray(resp.data.data)) arr = resp.data.data;
//                 }
//                 const wantedId = Number(CompId || companyIdParam || 0);
//                 const rec = arr.find(c => tryNum(c?.CompId ?? c?.CompID ?? 0) === wantedId) || arr[0];
//                 if (rec && Array.isArray(rec.formats)) {
//                     const norm = (s) => String(s || '').replace(/\s+/g, '').toLowerCase();
//                     const wantedNorm = norm(type);
//                     let found = null;
//                     for (const f of rec.formats) {
//                         const bName = norm(f?.BookName ?? '');
//                         const bId = Number(f?.BookID ?? f?.BookId ?? 0);
//                         if (bId && bName === wantedNorm) { found = bId; break; }
//                     }
//                     setAppliedFormat(found ?? 1);
//                 } else {
//                     setAppliedFormat(1);
//                 }
//             } catch (err) {
//                 console.warn('companies API error', err?.message);
//             }
//         }
//     };

//     const handleSelectSeries = (series) => {
//         setSelectedSeries(series);
//         setSelectedFormat(null);
//         const sId = getSeriesId(series);
//         const fmt = seriesFormats[sId] || null;
//         setAppliedFormat(fmt);
//     };

//     const handleCardClick = (format) => {
//         setSelectedFormat(format);
//         setPreviewOpen(true);
//     };

//     const handleApplyTemplate = async () => {
//         if (!selectedType || !selectedFormat) {
//             setSnack({ open: true, msg: 'Select a document type and format first.', severity: 'warning' });
//             return;
//         }
//         if (isMultiSeriesType && !selectedSeries) {
//             setSnack({ open: true, msg: 'Please select a series first.', severity: 'warning' });
//             return;
//         }
//         if (!CompId) {
//             setSnack({ open: true, msg: 'Unable to determine your company. Please select a company first.', severity: 'error' });
//             return;
//         }
//         const now = new Date();
//         const bookName = selectedType.replace(/\s+/g, '');
//         const seriesId = isMultiSeriesType ? getSeriesId(selectedSeries) : null;

//         const payload = {
//             GCompId: null, CompId,
//             BookName: bookName,
//             BookID: Number(selectedFormat),
//             FormName: isMultiSeriesType
//                 ? `${selectedType}-Series-${seriesId}-Format-${selectedFormat}`
//                 : `${selectedType}-Format-${selectedFormat}`,
//             CompDefault: 0, PPO: 0,
//             paperheight: 842, paperwidth: 595,
//             TopMargin: 0, LeftMargin: 0, RightMargin: 0, BottomMargin: 0,
//             Heading: '',
//             AddUserId: CURRENT_USER_ID, AddUserDateTime: toMySqlDT(now),
//             EditUserId: CURRENT_USER_ID, EditUserDateTime: toMySqlDT(now),
//             AppRegID,
//             ...(isMultiSeriesType && seriesId ? { SeriesId: seriesId } : {}),
//         };
//         try {
//             const res = await axios.post(`${API}/api/printmaster`, payload, { headers: { 'Content-Type': 'application/json' }, timeout: 15000 });
//             const ok = res?.data?.success === true || res?.data?.insertId || (res?.data?.affectedRows > 0);
//             if (ok) {
//                 const newFormat = Number(selectedFormat);
//                 setAppliedFormat(newFormat);
//                 if (isMultiSeriesType && selectedSeries) {
//                     const sId = getSeriesId(selectedSeries);
//                     setSeriesFormats(prev => ({ ...prev, [sId]: newFormat }));
//                 }
//                 setPreviewOpen(false);
//                 setSelectedFormat(null);
//                 const seriesLabel = isMultiSeriesType && selectedSeries
//                     ? ` for ${selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || 'series'}`
//                     : '';
//                 setSnack({ open: true, msg: `Format ${selectedFormat} applied successfully${seriesLabel}!`, severity: 'success' });
//             } else {
//                 setSnack({ open: true, msg: res?.data?.message || 'Failed to apply template.', severity: 'error' });
//             }
//         } catch (err) {
//             const msg = err.response?.data?.message || `Server error ${err.response?.status || ''}` || 'Network error.';
//             setSnack({ open: true, msg, severity: 'error' });
//         }
//     };

//     const showFormatGrid = selectedType && (!isMultiSeriesType || (isMultiSeriesType && selectedSeries));

//     const getActiveFormatLabel = () => {
//         if (isMultiSeriesType && selectedSeries) {
//             const sId = getSeriesId(selectedSeries);
//             const fmt = seriesFormats[sId];
//             if (fmt) {
//                 const sName = selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || `Series ${sId}`;
//                 return `Format ${fmt} — ${sName}`;
//             }
//             return null;
//         }
//         if (appliedFormat && selectedType && !isMultiSeriesType) return `Format ${appliedFormat} active`;
//         return null;
//     };

//     const activeLabel = getActiveFormatLabel();

//     // ─── RENDER ───────────────────────────────────────────────────────────────
//     return (
//         <Box sx={{ minHeight: "100vh", background: BG }}>

//             {/* ── TOPBAR ── */}
//             <Box sx={{
//                 background: "#fff", borderBottom: `0.5px solid ${BORDER}`,
//                 px: { xs: 2, sm: 3, md: 4 }, py: 1.5,
//                 display: "flex", alignItems: "center", justifyContent: "space-between",
//             }}>
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
//                     <Box sx={{
//                         width: 36, height: 36, background: FB, borderRadius: "9px",
//                         display: "flex", alignItems: "center", justifyContent: "center"
//                     }}>
//                         <FilePresent sx={{ color: "#fff", fontSize: 19 }} />
//                     </Box>
//                     <Box>
//                         <Typography sx={{ fontSize: 16, fontWeight: 500, color: T1, lineHeight: 1.2 }}>
//                             Printing <Box component="span" sx={{ color: FB }}>utilities</Box>
//                         </Typography>
//                         <Typography sx={{ fontSize: 11, color: T2 }}>
//                             Document template manager
//                         </Typography>
//                     </Box>
//                 </Box>
//                 {activeLabel && (
//                     <Box sx={{
//                         display: "flex", alignItems: "center", gap: "6px",
//                         px: "10px", py: "4px", bgcolor: GREEN_LT, borderRadius: "20px",
//                         border: `0.5px solid ${GREEN}44`,
//                     }}>
//                         <CheckCircle sx={{ fontSize: 13, color: GREEN }} />
//                         <Typography sx={{ fontSize: 12, fontWeight: 500, color: GREEN }}>
//                             {activeLabel}
//                         </Typography>
//                     </Box>
//                 )}
//             </Box>

//             {/* ── CONTENT ── */}
//             <Box sx={{ maxWidth: 1200, mx: "auto", px: { xs: 1.5, sm: 3, md: 4 }, py: { xs: 2, sm: 3, md: 4 } }}>

//                 {/* ── Step 1 — Type selector ── */}
//                 <Box sx={{ ...cardBaseSx, p: { xs: 1.5, sm: 2 }, mb: { xs: 1.5, sm: 2 } }}>
//                     <Typography sx={{
//                         fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".4px", mb: 1,
//                         display: "flex", alignItems: "center", gap: "6px"
//                     }}>
//                         <Box component="span" sx={{ width: 14, height: 14, bgcolor: FB, borderRadius: "4px", display: "inline-block" }} />
//                         Step 1 — Select document type
//                     </Typography>

//                     <FormControl fullWidth size="small">
//                         <Select value={selectedType} onChange={(e) => handleSelectType(e.target.value)}
//                             displayEmpty IconComponent={KeyboardArrowDown}
//                             renderValue={(val) => val || (
//                                 <Typography sx={{ fontSize: 13, color: T2 }}>Select a document type…</Typography>
//                             )}
//                             sx={{
//                                 bgcolor: BG, borderRadius: "8px", fontSize: 13,
//                                 "& .MuiOutlinedInput-notchedOutline": { borderColor: BORDER },
//                                 "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: FB_MID },
//                                 "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: FB, borderWidth: 2 },
//                                 "& .MuiSelect-select": { py: 1.25, px: 1.5, fontSize: 13, fontWeight: 500, color: T1 },
//                             }}
//                             MenuProps={{
//                                 PaperProps: {
//                                     sx: {
//                                         borderRadius: "10px", mt: 0.5,
//                                         border: `0.5px solid ${BORDER}`,
//                                         boxShadow: "0 8px 24px rgba(24,119,242,0.10)",
//                                     }
//                                 }
//                             }}
//                         >
//                             {documentTypes.map((type) => (
//                                 <MenuItem key={type} value={type}
//                                     sx={{
//                                         fontSize: 13, fontWeight: 500, color: T1, py: 1.25, px: 2, gap: 1.5,
//                                         "&:hover": { bgcolor: FB_LIGHT },
//                                         "&.Mui-selected": { bgcolor: FB_LIGHT, color: FB },
//                                         "&.Mui-selected:hover": { bgcolor: FB_LIGHT },
//                                     }}
//                                 >
//                                     <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: FB, flexShrink: 0 }} />
//                                     {type}
//                                     {MULTI_SERIES_TYPES.includes(type) && (
//                                         <Chip
//                                             label="Multi-series"
//                                             size="small"
//                                             sx={{
//                                                 ml: "auto", fontSize: 10, height: 20,
//                                                 bgcolor: FB_LIGHT, color: FB,
//                                                 border: `0.5px solid ${FB_MID}`,
//                                             }}
//                                         />
//                                     )}
//                                 </MenuItem>
//                             ))}
//                         </Select>
//                     </FormControl>
//                 </Box>

//                 {/* ── Step 1.5 — Series selector ── */}
//                 {isMultiSeriesType && selectedType && (
//                     <Fade in={isMultiSeriesType}>
//                         <Box sx={{ ...cardBaseSx, p: { xs: 1.5, sm: 2 }, mb: { xs: 1.5, sm: 2 } }}>
//                             <Typography sx={{
//                                 fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".4px", mb: 1,
//                                 display: "flex", alignItems: "center", gap: "6px"
//                             }}>
//                                 <Box component="span" sx={{ width: 14, height: 14, bgcolor: FB, borderRadius: "4px", display: "inline-block" }} />
//                                 Step 2 — Select series
//                                 <Chip
//                                     label="Multi-series document"
//                                     size="small"
//                                     sx={{
//                                         ml: 1, fontSize: 10, height: 20,
//                                         bgcolor: FB_LIGHT, color: FB,
//                                         border: `0.5px solid ${FB_MID}`,
//                                     }}
//                                 />
//                             </Typography>
//                             <Typography sx={{ fontSize: 13, color: T2, mb: 1.5 }}>
//                                 This document type supports multiple series. Select a series to set its format individually.
//                             </Typography>

//                             {loadingSeries ? (
//                                 <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", py: 4, gap: 1.5 }}>
//                                     <CircularProgress size={24} sx={{ color: FB }} />
//                                     <Typography sx={{ fontSize: 13, color: T2 }}>Loading series…</Typography>
//                                 </Box>
//                             ) : seriesList.length > 0 ? (
//                                 <Grid container spacing={{ xs: 1, sm: 1.5 }}>
//                                     {seriesList.map((series, index) => {
//                                         const sId = getSeriesId(series);
//                                         const isSelected = selectedSeries && getSeriesId(selectedSeries) === sId;
//                                         const sAppliedFormat = seriesFormats[sId] || null;
//                                         return (
//                                             <Grid item key={sId} xs={12} sm={6} md={4}>
//                                                 <SeriesCard
//                                                     series={series}
//                                                     isSelected={isSelected}
//                                                     appliedFormat={sAppliedFormat}
//                                                     onClick={handleSelectSeries}
//                                                     index={index}
//                                                 />
//                                             </Grid>
//                                         );
//                                     })}
//                                 </Grid>
//                             ) : (
//                                 <Box sx={{
//                                     py: 4, textAlign: "center",
//                                     border: `1.5px dashed ${BORDER}`, borderRadius: "10px",
//                                 }}>
//                                     <Box sx={{
//                                         width: 44, height: 44, bgcolor: FB_LIGHT, borderRadius: "11px",
//                                         display: "flex", alignItems: "center", justifyContent: "center",
//                                         mx: "auto", mb: 1,
//                                     }}>
//                                         <BarChart sx={{ fontSize: 22, color: FB_MID }} />
//                                     </Box>
//                                     <Typography sx={{ fontSize: 14, fontWeight: 500, color: T1, mb: "4px" }}>
//                                         No series found
//                                     </Typography>
//                                     <Typography sx={{ fontSize: 12, color: T2 }}>
//                                         No series available for {selectedType}. Please create a series first.
//                                     </Typography>
//                                 </Box>
//                             )}

//                             {seriesList.length > 0 && Object.keys(seriesFormats).length > 0 && (
//                                 <Box sx={{
//                                     mt: 2, p: 1.5, bgcolor: BG, borderRadius: "8px",
//                                     border: `0.5px solid ${BORDER}`,
//                                 }}>
//                                     <Typography sx={{ fontSize: 11, fontWeight: 500, color: T2, mb: 1, letterSpacing: ".3px" }}>
//                                         FORMAT SUMMARY
//                                     </Typography>
//                                     <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
//                                         {seriesList.map((series) => {
//                                             const sId = getSeriesId(series);
//                                             const sName = series?.SeriesName || series?.seriesName || series?.Name || series?.name || `Series ${sId}`;
//                                             const fmt = seriesFormats[sId];
//                                             return (
//                                                 <Chip
//                                                     key={sId}
//                                                     icon={fmt ? <CheckCircle sx={{ fontSize: 12, color: `${GREEN} !important` }} /> : undefined}
//                                                     label={`${sName}: ${fmt ? `Format ${fmt}` : 'Not set'}`}
//                                                     size="small"
//                                                     sx={{
//                                                         fontSize: 11, height: 24,
//                                                         bgcolor: fmt ? GREEN_LT : "#fff",
//                                                         color: fmt ? GREEN : T2,
//                                                         border: `0.5px solid ${fmt ? GREEN + '44' : BORDER}`,
//                                                         "& .MuiChip-icon": { ml: "6px" },
//                                                     }}
//                                                 />
//                                             );
//                                         })}
//                                     </Box>
//                                 </Box>
//                             )}
//                         </Box>
//                     </Fade>
//                 )}

//                 {/* ── Step 2/3 — Format grid ── */}
//                 {showFormatGrid ? (
//                     <Fade in={showFormatGrid}>
//                         <Box>
//                             <Box sx={{
//                                 ...cardBaseSx, px: { xs: 1.5, sm: 2 }, py: 1.5,
//                                 mb: { xs: 1.5, sm: 2 },
//                                 display: "flex", alignItems: "center", justifyContent: "space-between",
//                                 flexWrap: "wrap", gap: 1
//                             }}>
//                                 <Box>
//                                     <Typography sx={{
//                                         fontSize: 11, fontWeight: 500, color: T2, letterSpacing: ".4px", mb: "2px",
//                                         display: "flex", alignItems: "center", gap: "6px"
//                                     }}>
//                                         <Box component="span" sx={{ width: 14, height: 14, bgcolor: FB, borderRadius: "4px", display: "inline-block" }} />
//                                         Step {isMultiSeriesType ? '3' : '2'} — Choose format
//                                     </Typography>
//                                     <Typography sx={{ fontSize: 15, fontWeight: 500, color: T1 }}>
//                                         {selectedType} templates
//                                         {isMultiSeriesType && selectedSeries && (
//                                             <Box component="span" sx={{
//                                                 ml: 1, fontSize: 12, color: FB, fontWeight: 500,
//                                                 px: "8px", py: "2px", bgcolor: FB_LIGHT, borderRadius: "12px",
//                                                 border: `0.5px solid ${FB_MID}`,
//                                             }}>
//                                                 {selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || selectedSeries?.name || 'Selected Series'}
//                                             </Box>
//                                         )}
//                                         <Box component="span" sx={{ ml: 1, fontSize: 12, color: T2, fontWeight: 400 }}>
//                                             ({currentFormatCount} available)
//                                         </Box>
//                                     </Typography>
//                                 </Box>
//                                 {appliedFormat && (
//                                     <Box sx={{
//                                         display: "inline-flex", alignItems: "center", gap: "6px",
//                                         px: "10px", py: "4px", bgcolor: GREEN_LT, borderRadius: "20px",
//                                         border: `0.5px solid ${GREEN}44`
//                                     }}>
//                                         <CheckCircle sx={{ fontSize: 13, color: GREEN }} />
//                                         <Typography sx={{ fontSize: 12, fontWeight: 500, color: GREEN }}>
//                                             Format {appliedFormat} is active
//                                             {isMultiSeriesType && selectedSeries && (
//                                                 <Box component="span" sx={{ ml: 0.5, fontSize: 11, color: GREEN, opacity: 0.8 }}>
//                                                     for this series
//                                                 </Box>
//                                             )}
//                                         </Typography>
//                                     </Box>
//                                 )}
//                             </Box>

//                             <Grid container spacing={{ xs: 1.25, sm: 2 }}>
//                                 {Array.from({ length: currentFormatCount }, (_, i) => i + 1).map((format) => (
//                                     <Grid item key={format} xs={6} sm={4} md={3}>
//                                         <FormatCard
//                                             format={format}
//                                             selectedType={selectedType}
//                                             isApplied={appliedFormat === format}
//                                             onClick={() => handleCardClick(format)}
//                                         />
//                                     </Grid>
//                                 ))}
//                             </Grid>
//                         </Box>
//                     </Fade>
//                 ) : !selectedType ? (
//                     <Box sx={{
//                         ...cardBaseSx, py: { xs: 6, sm: 8 }, textAlign: "center",
//                         border: `1.5px dashed ${BORDER}`,
//                     }}>
//                         <Box sx={{
//                             width: 52, height: 52, bgcolor: FB_LIGHT, borderRadius: "13px",
//                             display: "flex", alignItems: "center", justifyContent: "center",
//                             mx: "auto", mb: 1.5,
//                         }}>
//                             <FilePresent sx={{ fontSize: 26, color: FB_MID }} />
//                         </Box>
//                         <Typography sx={{ fontSize: 15, fontWeight: 500, color: T1, mb: "4px" }}>
//                             No document type selected
//                         </Typography>
//                         <Typography sx={{ fontSize: 13, color: T2 }}>
//                             Select a type above to browse professional templates
//                         </Typography>
//                     </Box>
//                 ) : isMultiSeriesType && !selectedSeries ? (
//                     !loadingSeries && seriesList.length > 0 && (
//                         <Box sx={{
//                             ...cardBaseSx, py: { xs: 5, sm: 6 }, textAlign: "center",
//                             border: `1.5px dashed ${BORDER}`,
//                         }}>
//                             <Box sx={{
//                                 width: 52, height: 52, bgcolor: FB_LIGHT, borderRadius: "13px",
//                                 display: "flex", alignItems: "center", justifyContent: "center",
//                                 mx: "auto", mb: 1.5,
//                             }}>
//                                 <BarChart sx={{ fontSize: 26, color: FB_MID }} />
//                             </Box>
//                             <Typography sx={{ fontSize: 15, fontWeight: 500, color: T1, mb: "4px" }}>
//                                 Select a series to continue
//                             </Typography>
//                             <Typography sx={{ fontSize: 13, color: T2 }}>
//                                 Choose a series from above to set its template format
//                             </Typography>
//                         </Box>
//                     )
//                 ) : null}
//             </Box>

//             {/* ── Preview dialog ── */}
//             <PreviewDialog
//                 open={previewOpen}
//                 onClose={() => { setPreviewOpen(false); setSelectedFormat(null); }}
//                 selectedType={selectedType}
//                 selectedFormat={selectedFormat}
//                 appliedFormat={appliedFormat}
//                 onApply={handleApplyTemplate}
//                 selectedSeries={selectedSeries}
//             />

//             {/* ── Snackbar ── */}
//             <Snackbar open={snack.open} autoHideDuration={3000}
//                 onClose={() => setSnack(s => ({ ...s, open: false }))}
//                 anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
//             >
//                 <Alert severity={snack.severity} variant="filled"
//                     onClose={() => setSnack(s => ({ ...s, open: false }))}
//                     sx={{ borderRadius: "8px", fontWeight: 500 }}
//                 >
//                     {snack.msg}
//                 </Alert>
//             </Snackbar>
//         </Box>
//     );
// }















import { colors as themeColors } from '../utils/theme';
import React, { useRef, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import {
    Box, Typography, Grid, Card, CardMedia, CardContent, Chip,
    Dialog, DialogContent, Button, IconButton, Snackbar, Alert,
    Fade, Zoom, Skeleton, Tooltip, useTheme, useMediaQuery,
    CircularProgress, Checkbox, FormControlLabel, Popover,
} from '@mui/material';
import {
    CheckCircle, Close, ZoomIn, ZoomOut, OpenInFull, FilePresent,
    AutoAwesome, BarChart, ArrowForwardIos, PaletteOutlined,
    RequestQuoteOutlined, AssignmentOutlined, DescriptionOutlined,
    LocalShippingOutlined, ReceiptLongOutlined, ReceiptOutlined,
    UndoOutlined, PostAddOutlined, ShoppingCartOutlined, InventoryOutlined,
    AccountBalanceWalletOutlined,
} from '@mui/icons-material';

// ─── DESIGN TOKENS ────────────────────────────────────────────────────────────
// Premium SaaS palette — refined neutrals, soft layered shadows, one confident accent.
const FB = themeColors.primary.dark;
const FB_DARK = "#0d47a1";
const FB_LIGHT = "#eaf2fd";
const FB_MID = "#90caf9";
const FB_SOFT = "rgba(24,119,242,0.08)";
const GRAD_BRAND = `linear-gradient(135deg, ${themeColors.primary.main} 0%, #0B5CD6 100%)`;
const GRAD_SHEEN = "linear-gradient(135deg, rgba(255,255,255,0.22) 0%, rgba(255,255,255,0) 60%)";
const BG = "#f4f6fb";
const SURFACE = themeColors.neutral.surface;
const SURFACE_ALT = "#FAFCFE";
const BORDER = "#e3e8f0";
const BORDER_SOFT = "#EEF3F7";
const T1 = "#101828";
const T2 = themeColors.neutral.sub;
const T3 = "#90A4AE";
const GREEN = "#12805c";
const GREEN_LT = "#e6f6f0";
const GREEN_BORDER = "#A8E0C9";
const RED = themeColors.error.darker;

// Soft, layered elevation scale — replaces flat 1px-border cards.
const SHADOW_XS = "0 1px 2px rgba(28,43,57,0.04)";
const SHADOW_SM = "0 2px 10px rgba(28,43,57,0.06), 0 1px 2px rgba(28,43,57,0.04)";
const SHADOW_MD = "0 10px 30px rgba(28,43,57,0.08), 0 2px 6px rgba(28,43,57,0.04)";
const SHADOW_LG = "0 22px 50px rgba(28,43,57,0.14), 0 6px 16px rgba(28,43,57,0.06)";
const SHADOW_BRAND = "0 12px 30px rgba(24,119,242,0.22), 0 2px 8px rgba(24,119,242,0.12)";
const EASE = "cubic-bezier(0.16, 1, 0.3, 1)";

// ─── CONSTANTS ────────────────────────────────────────────────────────────────
const publicUrl = typeof process !== 'undefined' && process.env?.PUBLIC_URL ? process.env.PUBLIC_URL : '';
const dummyImg = `${publicUrl}/Quotation_Image.jpeg`;

// ✅ ALL document types now show A4 badge (display-only for formats 1-10)
// Sale Challan and Purchase Dispatch additionally get real A4/A5 variants for formats 11/12/13
const PAGE_SIZE_DOCUMENT_TYPES = [
    'Quotation',
    // 'Sale Order',
    'Proforma Invoice',
    'Sale Challan',
    'Sale Invoice',
    // 'Purchase Order',
    'Purchase Dispatch',
    'Purchase Invoice',
    'Credit Note',
    'Debit Note',
];

// ✅ Only formats 11/12/13 get real A4/A5 split variants (Sale Challan & Purchase Dispatch only)
const PAGE_SIZE_VARIANT_DOCUMENT_TYPES = ['Sale Challan', 'Purchase Dispatch'];
const PAGE_SIZE_CONFIGURABLE_FORMATS = [11, 12, 13];

// ✅ Format configuration for different document types
const FORMAT_CONFIG = {
    'Quotation': 10,
    'Proforma Invoice': 10,
    'Sale Challan': 13,
    'Sale Invoice': 23,
    'Purchase Order': 10,
    'Purchase Dispatch': 13,
    'Purchase Invoice': 10,
    'Credit Note': 17,
    'Debit Note': 10,
    'Credit Expense': 10,
    'Payable-Receivable': 2,
};

// ✅ Exclude specific formats from document types
const FORMAT_EXCLUSIONS = {
    'Sale Invoice': [11, 12, 13, 19, 20, 21, 22],
    'Credit Note': [11, 12, 13, 14, 15],
};

// ✅ Extra standalone formats appended after the numbered 1..count run
const EXTRA_FORMATS = {
    'Quotation': [900],
};

// ✅ Get format count for any document type
const getFormatCount = (type) => {
    return FORMAT_CONFIG[type] || 10;
};

// ✅ Build expanded format list with separate A4/A5 variants for configurable formats
// Each item: { format, pageSize, badgePageSize }
// - pageSize: actual page size value used for logic (null for non-variant, 'A4'/'A5' for variant)
// - badgePageSize: what badge to DISPLAY on the card (may be 'A4' for display-only on formats 1-10)
const buildFormatList = (type, count) => {
    const list = [];
    const excludedFormats = FORMAT_EXCLUSIONS[type] || [];
    for (let i = 1; i <= count; i++) {
        if (excludedFormats.includes(i)) continue;
        if (PAGE_SIZE_VARIANT_DOCUMENT_TYPES.includes(type) && PAGE_SIZE_CONFIGURABLE_FORMATS.includes(i)) {
            // ✅ Formats 11/12/13 for Sale Challan & Purchase Dispatch: split into real A4 and A5 variants
            list.push({ format: i, pageSize: 'A4', badgePageSize: 'A4' });
            list.push({ format: i, pageSize: 'A5', badgePageSize: 'A5' });
        } else if (PAGE_SIZE_DOCUMENT_TYPES.includes(type)) {
            // ✅ Formats 1-10, 14-15 for ALL PAGE_SIZE_DOCUMENT_TYPES: show A4 badge for display only
            // pageSize remains null so existing isVariantApplied logic is NOT affected
            list.push({ format: i, pageSize: null, badgePageSize: 'A4' });
        } else {
            // ✅ Any document types not in PAGE_SIZE_DOCUMENT_TYPES: no badge
            list.push({ format: i, pageSize: null, badgePageSize: null });
        }
    }
    (EXTRA_FORMATS[type] || []).forEach((extra) => {
        list.push({
            format: extra,
            pageSize: null,
            badgePageSize: PAGE_SIZE_DOCUMENT_TYPES.includes(type) ? 'A4' : null,
        });
    });
    return list;
};

const getImageForTypeFormat = (type = '', format = 0, pageSize = null) => {
    const idx = Number(format) || 0;
    const isExtraFormat = (EXTRA_FORMATS[type] || []).includes(idx);
    if (!idx || idx < 1 || (idx > 25 && !isExtraFormat)) return { thumb: dummyImg, large: dummyImg };
    const norm = (type || '').replace(/\s+/g, '').toLowerCase();
    const suffix = pageSize === 'A5' ? `${idx}A5` : idx;
    const build = (base) => `${publicUrl}/${base}${suffix}.jpg`;
    const map = {
        quotation: () => build('Quotation'),
        saleorder: () => build('SaleOrder'),
        proformainvoice: () => build('ProformaInvoice'),
        salechallan: () => build('SaleChallan'),
        saleinvoice: () => build('SaleInvoice'),
        creditnote: () => build('CreditNote'),
        purchaseorder: () => build('PurchaseOrder'),
        purchasedispatch: () => build('PurchaseChallan'),
        purchaseinvoice: () => build('PurchaseInvoice'),
        debitnote: () => build('DebitNote'),
        creditexpense: () => build('PurchaseInvoice'),
        'payable-receivable': () => build('PayableReceivable'),
    };
    const src = map[norm] ? map[norm]() : dummyImg;
    return { thumb: src, large: src };
};

const documentTypes = [
    'Quotation',
    'Sale Order',
    'Proforma Invoice',
    'Sale Challan',
    'Sale Invoice',
    'Credit Note',
    'Purchase Order',
    'Purchase Dispatch',
    'Purchase Invoice',
    'Debit Note',
    'Credit Expense',
    'Payable-Receivable',
];

// Document types that support multiple series
const MULTI_SERIES_TYPES = ['Sale Challan', 'Sale Invoice', 'Proforma Invoice', 'Credit Note', 'Payable-Receivable'];

// "Payable-Receivable" is book-wise instead of series-wise: its four books are listed where the series
// selector normally is, and each book (BookName BKP / CBP / BKR / CBR) keeps its own format.
// SeriesId here is only a local key for the cards; it is never sent to the server.
const BOOKWISE_TYPES = ['Payable-Receivable'];
const PAY_RECEIVE_BOOKS = [
    { SeriesId: 1, SeriesName: 'Bank Payment', BookCode: 'BKP' },
    { SeriesId: 2, SeriesName: 'Cash Payment', BookCode: 'CBP' },
    { SeriesId: 3, SeriesName: 'Bank Receipt', BookCode: 'BKR' },
    { SeriesId: 4, SeriesName: 'Cash Receipt', BookCode: 'CBR' },
];

// Plan-based visibility: "Billing" plan only shows these 4; "Accounting" (or any
// other/unknown plan) shows every type in documentTypes, unchanged.
const BILLING_PLAN_DOC_TYPES = ['Quotation', 'Sale Challan', 'Sale Invoice', 'Credit Note'];

// ─── Per-document-type icon lookup (additive, decorative only — does not touch documentTypes values) ──
const DOC_TYPE_ICONS = {
    'Quotation': RequestQuoteOutlined,
    'Sale Order': ShoppingCartOutlined,
    'Proforma Invoice': DescriptionOutlined,
    'Sale Challan': LocalShippingOutlined,
    'Sale Invoice': ReceiptOutlined,
    'Credit Note': UndoOutlined,
    'Purchase Order': AssignmentOutlined,
    'Purchase Dispatch': InventoryOutlined,
    'Purchase Invoice': ReceiptLongOutlined,
    'Debit Note': PostAddOutlined,
    'Credit Expense': ReceiptLongOutlined,
    'Payable-Receivable': AccountBalanceWalletOutlined,
};
const getDocTypeIcon = (type) => DOC_TYPE_ICONS[type] || FilePresent;

const FORMAT_COUNT = 10;
const formats = Array.from({ length: FORMAT_COUNT }, (_, i) => i + 1);

// ─── SHARED SX ────────────────────────────────────────────────────────────────
const cardBaseSx = {
    background: SURFACE, border: `1px solid ${BORDER}`, borderRadius: '18px', overflow: 'hidden',
    boxShadow: SHADOW_SM, transition: `box-shadow 0.3s ${EASE}`,
};

const btnPrimarySx = {
    background: GRAD_BRAND, color: themeColors.neutral.surface, borderRadius: '10px', fontSize: 13.5, fontWeight: 700,
    textTransform: "none", px: 2.75, height: 40, letterSpacing: '0.1px',
    boxShadow: SHADOW_BRAND, transition: `all 0.25s ${EASE}`,
    "&:hover": { background: GRAD_BRAND, boxShadow: '0 14px 32px rgba(21,101,192,0.24), 0 4px 10px rgba(21,101,192,0.14)', transform: 'translateY(-1px)' },
    "&:active": { transform: 'translateY(0)' },
    "&:disabled": { background: '#cfd8e3', color: themeColors.neutral.surface, boxShadow: 'none' },
};

const btnGhostSx = {
    background: SURFACE, color: T2, border: `1px solid ${BORDER}`, borderRadius: '10px',
    fontSize: 13.5, fontWeight: 600, textTransform: "none", px: 2.75, height: 40,
    transition: `all 0.2s ${EASE}`,
    "&:hover": { background: SURFACE_ALT, color: T1, borderColor: themeColors.neutral.lineStrong },
};

// ─── HELPER: check if page size toggle should show ────────────────────────────
const shouldShowPageSize = (docType, format) => {
    return (
        PAGE_SIZE_DOCUMENT_TYPES.includes(docType) &&
        PAGE_SIZE_CONFIGURABLE_FORMATS.includes(Number(format))
    );
};

// ─── SERIES CARD ──────────────────────────────────────────────────────────────
function SeriesCard({ series, isSelected, appliedFormat, onClick, index }) {
    const seriesName = series?.SeriesName || series?.seriesName || series?.Name || series?.name || `Series ${series?.SeriesId || series?.SeriesID || index + 1}`;
    const seriesId = series?.SeriesId || series?.SeriesID || series?.seriesId || series?.Id || series?.id || index + 1;

    return (
        <Zoom in style={{ transitionDelay: `${index * 35}ms` }}>
            <Box
                role="button"
                tabIndex={0}
                onClick={() => onClick(series)}
                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick(series); } }}
                sx={{
                    position: "relative", display: "flex", alignItems: "center", gap: 1.5,
                    p: 1.6, borderRadius: "16px", cursor: "pointer", bgcolor: isSelected ? themeColors.neutral.surface : SURFACE,
                    border: `1.5px solid ${isSelected ? FB : BORDER_SOFT}`,
                    boxShadow: isSelected ? `0 0 0 4px ${FB_SOFT}, ${SHADOW_MD}` : SHADOW_XS,
                    transition: `all 0.28s ${EASE}`,
                    "&:hover": { borderColor: FB_MID, boxShadow: SHADOW_MD, transform: "translateY(-2px)" },
                    "@media (prefers-reduced-motion: reduce)": { transition: "none", "&:hover": { transform: "none" } },
                    "&:focus-visible": { outline: `2px solid ${FB}`, outlineOffset: 2 },
                }}
            >
                <Box sx={{
                    width: 40, height: 40, borderRadius: "12px", flexShrink: 0,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    background: isSelected ? GRAD_BRAND : FB_LIGHT,
                    boxShadow: isSelected ? SHADOW_BRAND : "none", transition: `all 0.28s ${EASE}`,
                }}>
                    <BarChart sx={{ fontSize: 19, color: isSelected ? themeColors.neutral.surface : FB }} />
                </Box>

                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography noWrap sx={{ fontSize: 13.5, fontWeight: 700, color: T1, letterSpacing: "-0.2px" }}>{seriesName}</Typography>
                    <Typography sx={{ fontSize: 11, color: T3, mt: 0.2, fontWeight: 600 }}>Series {String(seriesId)}</Typography>
                </Box>

                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 0.8, flexShrink: 0 }}>
                    {appliedFormat ? (
                        <Box sx={{ px: 1, py: 0.25, borderRadius: "999px", bgcolor: GREEN_LT, border: `1px solid ${GREEN_BORDER}` }}>
                            <Typography sx={{ fontSize: 10.5, fontWeight: 700, color: GREEN }}>FMT {String(appliedFormat).padStart(2, "0")}</Typography>
                        </Box>
                    ) : (
                        <Box sx={{ px: 1, py: 0.25, borderRadius: "999px", bgcolor: SURFACE_ALT, border: `1px solid ${BORDER}` }}>
                            <Typography sx={{ fontSize: 10.5, fontWeight: 600, color: T3 }}>Not set</Typography>
                        </Box>
                    )}
                    {isSelected && (
                        <Box sx={{ width: 18, height: 18, borderRadius: "50%", background: GRAD_BRAND, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: SHADOW_BRAND }}>
                            <CheckCircle sx={{ fontSize: 12, color: themeColors.neutral.surface }} />
                        </Box>
                    )}
                </Box>
            </Box>
        </Zoom>
    );
}

// ─── FORMAT CARD ──────────────────────────────────────────────────────────────
// ✅ Accepts pageSize (logic) and badgePageSize (display-only) props
function FormatCard({ format, pageSize, badgePageSize, selectedType, isApplied, onClick, cardIndex }) {
    const [imgLoaded, setImgLoaded] = useState(false);
    const { thumb } = getImageForTypeFormat(selectedType, format, pageSize);

    // ✅ This card is a real page-size variant if pageSize is not null (A4 or A5 selectable)
    const isPageSizeVariant = pageSize !== null && pageSize !== undefined;

    const showBadge = badgePageSize !== null && badgePageSize !== undefined;

    // Consolidated single-corner label: "FMT-01 · A4" instead of 3 scattered badges
    const cornerLabel = showBadge ? `FMT-${String(format).padStart(2, '0')} · ${badgePageSize}` : `FMT-${String(format).padStart(2, '0')}`;

    return (
        <Zoom in style={{ transitionDelay: `${cardIndex * 30}ms` }}>
            <Box
                role="button"
                tabIndex={0}
                onClick={onClick}
                onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick(); } }}
                sx={{
                    position: "relative", cursor: "pointer", borderRadius: "18px", overflow: "hidden", bgcolor: themeColors.neutral.surface,
                    border: `1.5px solid ${isApplied ? FB : BORDER_SOFT}`,
                    boxShadow: isApplied ? `0 0 0 4px ${FB_SOFT}, ${SHADOW_MD}` : SHADOW_XS,
                    transition: `all 0.3s ${EASE}`,
                    "&:hover": { borderColor: FB_MID, boxShadow: SHADOW_LG, transform: "translateY(-4px)" },
                    "@media (prefers-reduced-motion: reduce)": { transition: "none", "&:hover": { transform: "none" }, "&:hover .fc-thumb": { transform: "none" } },
                    "&:hover .fc-stage": { opacity: 1 },
                    "&:hover .fc-thumb": { transform: "scale(1.04)" },
                    "&:focus-visible": { outline: `2px solid ${FB}`, outlineOffset: 2 },
                }}
            >
                <Box sx={{ position: "relative", aspectRatio: "3 / 4", bgcolor: SURFACE_ALT, overflow: "hidden" }}>
                    {!imgLoaded && (
                        <Skeleton variant="rectangular" width="100%" height="100%" animation="wave" sx={{ bgcolor: "#e9eef4" }} />
                    )}
                    <Box
                        component="img"
                        className="fc-thumb"
                        src={thumb}
                        alt={`Format ${format}${isPageSizeVariant ? ` ${pageSize}` : ""}`}
                        onLoad={() => setImgLoaded(true)}
                        onError={(e) => { e.currentTarget.src = dummyImg; setImgLoaded(true); }}
                        sx={{ width: "100%", height: "100%", objectFit: "cover", display: imgLoaded ? "block" : "none", transition: `transform 0.5s ${EASE}` }}
                    />
                    <Box sx={{ position: "absolute", inset: 0, background: "linear-gradient(180deg, rgba(12,21,38,0) 55%, rgba(12,21,38,0.35) 100%)", pointerEvents: "none" }} />

                    {/* Hover stage — centered preview pill */}
                    <Box className="fc-stage" sx={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", opacity: 0, transition: `opacity 0.25s ${EASE}`, bgcolor: "rgba(12,21,38,0.25)", backdropFilter: "blur(2px)" }}>
                        <Box sx={{ px: 1.6, py: 0.7, borderRadius: "999px", bgcolor: themeColors.neutral.surface, boxShadow: SHADOW_MD }}>
                            <Typography sx={{ fontSize: 12, fontWeight: 700, color: FB }}>Preview</Typography>
                        </Box>
                    </Box>

                    <Box sx={{ position: "absolute", top: 10, left: 10, px: 1, py: 0.35, borderRadius: "8px", bgcolor: isApplied ? FB : "rgba(12,21,38,0.6)", backdropFilter: "blur(6px)" }}>
                        <Typography sx={{ fontSize: 10.5, fontWeight: 700, color: themeColors.neutral.surface, letterSpacing: "0.3px" }}>{cornerLabel}</Typography>
                    </Box>
                    {isApplied && (
                        <Box sx={{ position: "absolute", top: 10, right: 10, width: 24, height: 24, borderRadius: "50%", bgcolor: GREEN, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 2px 8px rgba(18,128,92,0.4)" }}>
                            <CheckCircle sx={{ fontSize: 14, color: themeColors.neutral.surface }} />
                        </Box>
                    )}
                </Box>

                <Box sx={{ px: 1.6, py: 1.2, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, borderTop: `1px solid ${BORDER_SOFT}` }}>
                    <Box sx={{ minWidth: 0 }}>
                        <Typography sx={{ fontSize: 13, fontWeight: 700, color: T1, letterSpacing: "-0.1px" }}>Template {String(format).padStart(2, "0")}</Typography>
                        {isPageSizeVariant && <Typography sx={{ fontSize: 11, color: T3, fontWeight: 600 }}>{pageSize}</Typography>}
                    </Box>
                    <Box sx={{ px: 1, py: 0.3, borderRadius: "999px", bgcolor: isApplied ? GREEN_LT : FB_SOFT, border: `1px solid ${isApplied ? GREEN_BORDER : FB_MID}` }}>
                        <Typography sx={{ fontSize: 10.5, fontWeight: 700, color: isApplied ? GREEN : FB }}>{isApplied ? "Active" : "Use"}</Typography>
                    </Box>
                </Box>
            </Box>
        </Zoom>
    );
}

// ─── PREVIEW DIALOG ───────────────────────────────────────────────────────────
// ✅ pageSize is passed in as fixed value from the clicked card — NOT changeable in dialog
function PreviewDialog({ open, onClose, selectedType, selectedFormat, onApply, appliedFormat, selectedSeries, appliedPageSize, pageSize }) {
    const scaleRef = useRef(1);
    const originRef = useRef({ x: 50, y: 50 });
    const translateRef = useRef({ x: 0, y: 0 });
    const isDraggingRef = useRef(false);
    const dragStartRef = useRef({ mouseX: 0, mouseY: 0, translateX: 0, translateY: 0 });

    // ── React state only for triggering re-renders ──
    const [scale, setScale] = useState(1);
    const [origin, setOrigin] = useState({ x: 50, y: 50 });
    const [translate, setTranslate] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);

    const containerRef = useRef(null);

    const { large } = getImageForTypeFormat(selectedType, selectedFormat, pageSize);
    const isMobile = useMediaQuery(useTheme().breakpoints.down('sm'));
    const isMultiSeries = MULTI_SERIES_TYPES.includes(selectedType);
    const seriesName = selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || selectedSeries?.name || '';

    // ✅ Show page size info bar for ALL PAGE_SIZE_DOCUMENT_TYPES (formats 1-10 display A4, 11-13 real A4/A5)
    const showPageSizeInfo = PAGE_SIZE_DOCUMENT_TYPES.includes(selectedType) && selectedFormat != null;

    // ✅ isAlreadyApplied checks format AND pageSize match
    // For formats 1-10 (pageSize=null from card click), just check format match
    const isAlreadyApplied = appliedFormat === selectedFormat &&
        (!shouldShowPageSize(selectedType, selectedFormat) || appliedPageSize === pageSize);

    // ── Master reset ──────────────────────────────────────────────────────────
    const resetAll = useCallback(() => {
        scaleRef.current = 1;
        originRef.current = { x: 50, y: 50 };
        translateRef.current = { x: 0, y: 0 };
        isDraggingRef.current = false;
        setScale(1);
        setOrigin({ x: 50, y: 50 });
        setTranslate({ x: 0, y: 0 });
        setIsDragging(false);
    }, []);

    // ── Reset when dialog closes ──────────────────────────────────────────────
    useEffect(() => {
        if (!open) resetAll();
    }, [open, resetAll]);

    // ── Get pointer position as % inside the container ────────────────────────
    const getPointerOrigin = useCallback((clientX, clientY) => {
        const container = containerRef.current;
        if (!container) return { x: 50, y: 50 };
        const rect = container.getBoundingClientRect();
        const x = Math.min(Math.max(((clientX - rect.left) / rect.width) * 100, 0), 100);
        const y = Math.min(Math.max(((clientY - rect.top) / rect.height) * 100, 0), 100);
        return { x, y };
    }, []);

    // ── Core zoom function — reads/writes refs, then syncs state ──────────────
    const applyZoom = useCallback((delta, pointerOrigin) => {
        const newScale = Math.min(Math.max(scaleRef.current * delta, 0.4), 5);
        scaleRef.current = newScale;

        if (pointerOrigin) {
            originRef.current = pointerOrigin;
            setOrigin({ ...pointerOrigin });
        }

        // Auto-reset translation when fully zoomed out
        if (newScale <= 1) {
            translateRef.current = { x: 0, y: 0 };
            setTranslate({ x: 0, y: 0 });
        }

        setScale(newScale);
    }, []);

    // ── Wheel handler ─────────────────────────────────────────────────────────
    const handleWheel = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        const po = getPointerOrigin(e.clientX, e.clientY);
        const delta = e.deltaY > 0 ? 0.93 : 1.07;
        applyZoom(delta, po);
    }, [getPointerOrigin, applyZoom]);

    // ── Attach wheel listener with { passive: false } ─────────────────────────
    useEffect(() => {
        const el = containerRef.current;
        if (!el || !open) return;
        el.addEventListener('wheel', handleWheel, { passive: false });
        return () => { el.removeEventListener('wheel', handleWheel); };
    }, [open, handleWheel]);

    // ── Button zoom ───────────────────────────────────────────────────────────
    const handleZoomIn = useCallback(() => { applyZoom(1.25, originRef.current); }, [applyZoom]);
    const handleZoomOut = useCallback(() => { applyZoom(0.8, originRef.current); }, [applyZoom]);
    const handleReset = useCallback(() => { resetAll(); }, [resetAll]);

    // ── Mouse move ────────────────────────────────────────────────────────────
    const handleMouseMove = useCallback((e) => {
        if (!isDraggingRef.current) {
            originRef.current = getPointerOrigin(e.clientX, e.clientY);
            return;
        }
        const dx = e.clientX - dragStartRef.current.mouseX;
        const dy = e.clientY - dragStartRef.current.mouseY;
        const newTranslate = {
            x: dragStartRef.current.translateX + dx,
            y: dragStartRef.current.translateY + dy,
        };
        translateRef.current = newTranslate;
        setTranslate({ ...newTranslate });
    }, [getPointerOrigin]);

    // ── Mouse down ────────────────────────────────────────────────────────────
    const handleMouseDown = useCallback((e) => {
        if (scaleRef.current <= 1) return;
        e.preventDefault();
        isDraggingRef.current = true;
        setIsDragging(true);
        dragStartRef.current = {
            mouseX: e.clientX,
            mouseY: e.clientY,
            translateX: translateRef.current.x,
            translateY: translateRef.current.y,
        };
    }, []);

    // ── Mouse up ──────────────────────────────────────────────────────────────
    const handleMouseUp = useCallback(() => {
        if (!isDraggingRef.current) return;
        isDraggingRef.current = false;
        setIsDragging(false);
    }, []);

    // ── Mouse leave ───────────────────────────────────────────────────────────
    const handleMouseLeave = useCallback(() => {
        if (!isDraggingRef.current) return;
        isDraggingRef.current = false;
        setIsDragging(false);
    }, []);

    // ── Touch handlers ────────────────────────────────────────────────────────
    const handleTouchStart = useCallback((e) => {
        if (scaleRef.current <= 1 || e.touches.length !== 1) return;
        const touch = e.touches[0];
        isDraggingRef.current = true;
        setIsDragging(true);
        dragStartRef.current = {
            mouseX: touch.clientX,
            mouseY: touch.clientY,
            translateX: translateRef.current.x,
            translateY: translateRef.current.y,
        };
    }, []);

    const handleTouchMove = useCallback((e) => {
        if (!isDraggingRef.current || e.touches.length !== 1) return;
        e.preventDefault();
        const touch = e.touches[0];
        const dx = touch.clientX - dragStartRef.current.mouseX;
        const dy = touch.clientY - dragStartRef.current.mouseY;
        const newTranslate = {
            x: dragStartRef.current.translateX + dx,
            y: dragStartRef.current.translateY + dy,
        };
        translateRef.current = newTranslate;
        setTranslate({ ...newTranslate });
    }, []);

    const handleTouchEnd = useCallback(() => {
        isDraggingRef.current = false;
        setIsDragging(false);
    }, []);

    // ── Attach touchmove with { passive: false } ──────────────────────────────
    useEffect(() => {
        const el = containerRef.current;
        if (!el || !open) return;
        el.addEventListener('touchmove', handleTouchMove, { passive: false });
        return () => { el.removeEventListener('touchmove', handleTouchMove); };
    }, [open, handleTouchMove]);

    // ✅ Resolve the display page size for the info bar:
    // - For formats 11–13 of Sale Challan/Purchase Dispatch: show whichever was clicked ('A4' or 'A5')
    // - For formats 1–10 of ALL PAGE_SIZE_DOCUMENT_TYPES: always show 'A4' (display only)
    const displayPageSize = shouldShowPageSize(selectedType, selectedFormat)
        ? (pageSize || 'A4')   // 11–13: use passed pageSize
        : 'A4';                 // 1–10 of ALL PAGE_SIZE_DOCUMENT_TYPES: always A4

    // ─────────────────────────────────────────────────────────────────────────
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth fullScreen={isMobile} TransitionComponent={Fade}
            PaperProps={{ sx: { borderRadius: isMobile ? 0 : "22px", overflow: "hidden", maxHeight: isMobile ? "100vh" : "92vh", bgcolor: themeColors.neutral.surface, boxShadow: SHADOW_LG, backgroundImage: "none" } }}
        >
            {/* Header */}
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1.5, flexWrap: "wrap", px: { xs: 2, sm: 2.8 }, py: 1.9, borderBottom: `1px solid ${BORDER_SOFT}` }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.4, minWidth: 0 }}>
                    <Box sx={{ width: 36, height: 36, borderRadius: "11px", background: GRAD_BRAND, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: SHADOW_BRAND, flexShrink: 0 }}>
                        <FilePresent sx={{ fontSize: 18, color: themeColors.neutral.surface }} />
                    </Box>
                    <Box sx={{ minWidth: 0 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.8, flexWrap: "wrap" }}>
                            <Typography sx={{ fontSize: 15, fontWeight: 800, color: T1, letterSpacing: "-0.2px" }}>{selectedType}</Typography>
                            {isMultiSeries && seriesName && (
                                <Box sx={{ px: 1, py: 0.2, borderRadius: "999px", bgcolor: FB_SOFT }}>
                                    <Typography sx={{ fontSize: 11, fontWeight: 700, color: FB }}>{seriesName}</Typography>
                                </Box>
                            )}
                        </Box>
                        <Typography sx={{ fontSize: 12, color: T3, mt: 0.2, fontWeight: 600 }}>Template {String(selectedFormat || "").padStart(2, "0")}</Typography>
                    </Box>
                </Box>

                {/* Zoom toolbar */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.4, p: 0.4, borderRadius: "12px", bgcolor: BG, border: `1px solid ${BORDER_SOFT}` }}>
                    <IconButton size="small" onClick={handleZoomOut} aria-label="Zoom out" sx={{ color: T2, minWidth: 44, minHeight: 44, borderRadius: "9px", "&:hover": { bgcolor: themeColors.neutral.surface, color: FB } }}>
                        <ZoomOut sx={{ fontSize: 17 }} />
                    </IconButton>
                    <Typography sx={{ minWidth: 48, textAlign: "center", fontSize: 12, fontWeight: 700, color: T1, fontVariantNumeric: "tabular-nums" }}>{Math.round(scale * 100)}%</Typography>
                    <IconButton size="small" onClick={handleZoomIn} aria-label="Zoom in" sx={{ color: T2, minWidth: 44, minHeight: 44, borderRadius: "9px", "&:hover": { bgcolor: themeColors.neutral.surface, color: FB } }}>
                        <ZoomIn sx={{ fontSize: 17 }} />
                    </IconButton>
                    <Box sx={{ width: 1, height: 18, bgcolor: BORDER, mx: 0.4 }} />
                    <IconButton size="small" onClick={handleReset} aria-label="Reset zoom" sx={{ color: T2, minWidth: 44, minHeight: 44, borderRadius: "9px", "&:hover": { bgcolor: themeColors.neutral.surface, color: FB } }}>
                        <OpenInFull sx={{ fontSize: 15 }} />
                    </IconButton>
                    <IconButton size="small" onClick={onClose} aria-label="Close" sx={{ color: T2, minWidth: 44, minHeight: 44, borderRadius: "9px", "&:hover": { bgcolor: themeColors.neutral.surface, color: RED } }}>
                        <Close sx={{ fontSize: 17 }} />
                    </IconButton>
                </Box>
            </Box>

            {/* Page size strip */}
            {showPageSizeInfo && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, px: { xs: 2, sm: 2.8 }, py: 1, bgcolor: FB_LIGHT, borderBottom: `1px solid ${BORDER_SOFT}` }}>
                    <Typography sx={{ fontSize: 11, fontWeight: 700, color: T2, letterSpacing: "0.5px", textTransform: "uppercase" }}>Page size</Typography>
                    <Box sx={{ px: 1.1, py: 0.2, borderRadius: "999px", background: displayPageSize === "A4" ? GRAD_BRAND : `linear-gradient(135deg, ${GREEN} 0%, #0d5f45 100%)` }}>
                        <Typography sx={{ fontSize: 11, fontWeight: 700, color: themeColors.neutral.surface }}>{displayPageSize}</Typography>
                    </Box>
                    <Typography sx={{ fontSize: 11.5, color: T2 }}>{displayPageSize === "A4" ? "210 × 297 mm" : "148 × 210 mm"}</Typography>
                </Box>
            )}

            {/* Stage */}
            <DialogContent
                ref={containerRef}
                sx={{
                    p: 0, display: "flex", alignItems: "center", justifyContent: "center",
                    minHeight: isMobile ? "calc(100vh - 170px)" : 440, overflow: "hidden", position: "relative", userSelect: "none",
                    cursor: isDragging ? "grabbing" : scale > 1 ? "grab" : "zoom-in",
                    background: `radial-gradient(circle at 50% 40%, ${themeColors.neutral.surface} 0%, ${BG} 70%)`,
                    backgroundImage: `radial-gradient(circle at 50% 40%, ${themeColors.neutral.surface} 0%, ${BG} 70%), radial-gradient(${BORDER} 1px, transparent 1px)`,
                    backgroundSize: "cover, 22px 22px",
                }}
                onMouseMove={handleMouseMove}
                onMouseDown={handleMouseDown}
                onMouseUp={handleMouseUp}
                onMouseLeave={handleMouseLeave}
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}
            >
                <Box sx={{ transition: isDragging ? "none" : `transform 0.25s ${EASE}`, transform: `translate(${translate.x}px, ${translate.y}px) scale(${scale})`, transformOrigin: `${origin.x}% ${origin.y}%`, p: 3 }}>
                    <Box component="img" src={large} alt="Template preview" draggable={false} onError={(e) => { e.currentTarget.src = dummyImg; }}
                        sx={{ display: "block", maxWidth: "100%", maxHeight: isMobile ? "70vh" : "60vh", objectFit: "contain", borderRadius: "10px", boxShadow: SHADOW_MD, pointerEvents: "none", userSelect: "none" }}
                    />
                </Box>
            </DialogContent>

            {/* Footer */}
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1.5, flexWrap: "wrap", px: { xs: 2, sm: 2.8 }, py: 1.7, borderTop: `1px solid ${BORDER_SOFT}`, bgcolor: themeColors.neutral.surface }}>
                <Typography sx={{ fontSize: 12, color: T2 }}>
                    {showPageSizeInfo ? <>Prints on <Box component="span" sx={{ fontWeight: 700, color: T1 }}>{displayPageSize}</Box></> : "Review the template, then apply it"}
                </Typography>
                <Box sx={{ display: "flex", gap: 1 }}>
                    <Button onClick={onClose} sx={{ ...btnGhostSx, borderRadius: "12px" }}>Cancel</Button>
                    <Button
                        onClick={onApply}
                        disabled={isAlreadyApplied}
                        startIcon={isAlreadyApplied ? <CheckCircle sx={{ fontSize: 15 }} /> : <AutoAwesome sx={{ fontSize: 15 }} />}
                        sx={{
                            ...btnPrimarySx, borderRadius: "12px",
                            ...(isAlreadyApplied && { background: GREEN_LT, color: GREEN, border: `1px solid ${GREEN_BORDER}`, boxShadow: "none", "&:disabled": { background: GREEN_LT, color: GREEN, boxShadow: "none" } }),
                        }}
                    >
                        {isAlreadyApplied ? "Currently active" : "Apply template"}
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
}

// ─── MAIN ─────────────────────────────────────────────────────────────────────
export default function FormatSelectionScreen({ loggedInUser, companyData, connectionString }) {
    const API = connectionString;
    const auth = useAuth();
    const { selectedCompany } = useAuth();
    const authSelectedCompany = auth?.selectedCompany ?? null;
    const muiTheme = useTheme();
    const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(muiTheme.breakpoints.down('md'));

    const [selectedType, setSelectedType] = useState('');
    const [selectedFormat, setSelectedFormat] = useState(null);
    // ✅ Track selected page size from card click
    const [selectedCardPageSize, setSelectedCardPageSize] = useState(null);
    const [appliedFormat, setAppliedFormat] = useState(null);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [snack, setSnack] = useState({ open: false, msg: '', severity: 'success' });

    // ✅ State to track current format count
    const [currentFormatCount, setCurrentFormatCount] = useState(FORMAT_COUNT);

    // ✅ Page size state — stored per unique key (type + series + format + pageSize)
    const [pageSizeMap, setPageSizeMap] = useState({});
    const [appliedPageSize, setAppliedPageSize] = useState(null);

    // ✅ Track applied format+pageSize combos separately for variant cards
    const [appliedVariantMap, setAppliedVariantMap] = useState({});

    // Multi-series states
    const [seriesList, setSeriesList] = useState([]);
    const [selectedSeries, setSelectedSeries] = useState(null);
    const [seriesFormats, setSeriesFormats] = useState({});
    const [seriesPageSizes, setSeriesPageSizes] = useState({});
    const [loadingSeries, setLoadingSeries] = useState(false);

    // Signature checkbox state
    const [signatureChecked, setSignatureChecked] = useState(false);
    // QR Code checkbox state (Sale Invoice only)
    const [qrCodeChecked, setQrCodeChecked] = useState(false);
    // Color picker state
    const [selectedColor, setSelectedColor] = useState('#FF0000');
    const [colorAnchor, setColorAnchor] = useState(null);

    const AppRegID = selectedCompany?.AppRegID || null;
    const isMultiSeriesType = MULTI_SERIES_TYPES.includes(selectedType);
    const isBookWiseType = BOOKWISE_TYPES.includes(selectedType);
    // BookName used for saving / looking up the format: the selected book's code for book-wise types, else the type itself.
    const effectiveBookName = isBookWiseType ? (selectedSeries?.BookCode || selectedType) : selectedType;

    // ── Company resolution ────────────────────────────────────────────────────
    const companyFromProp = Array.isArray(companyData) ? companyData[0] : (companyData || null);
    let fallbackLS = null;
    try {
        const s = typeof window !== 'undefined' ? window.localStorage.getItem('selectedCompany') : null;
        if (s) fallbackLS = JSON.parse(s);
    } catch { fallbackLS = null; }

    const companyObj = authSelectedCompany || companyFromProp
        || (loggedInUser && (loggedInUser.selectedCompany || loggedInUser.company || loggedInUser.companyData))
        || fallbackLS || {};

    // ── Plan-based document-type visibility ─────────────────────────────────
    // "Billing" plan  -> Quotation, Sale Challan, Sale Invoice, Credit Note only.
    // "Accounting" plan (or any other/unknown plan) -> every document type, unchanged.
    const planName = selectedCompany?.planName || companyObj?.planName;
    const visibleDocumentTypes = planName === 'Billing'
        ? documentTypes.filter(t => BILLING_PLAN_DOC_TYPES.includes(t))
        : documentTypes;

    const tryNum = (v) => { if (v == null || v === '') return 0; const n = Number(v); return isFinite(n) ? n : 0; };
    const GCompId_RAW = companyObj?.GCompId ?? companyObj?.GCompid ?? companyObj?.GCompID ?? null;
    const GCompId = (GCompId_RAW == null || GCompId_RAW === '') ? null : tryNum(GCompId_RAW);

    let CompId = 0;
    for (const c of [companyObj?.CompId, companyObj?.CompID, companyObj?.Compid, companyObj?.CompanyId, loggedInUser?.CompId, loggedInUser?.CompanyId]) {
        const n = tryNum(c);
        if (n > 0) { CompId = n; break; }
    }
    if (!CompId && fallbackLS) {
        for (const c of [fallbackLS?.CompId, fallbackLS?.CompID, fallbackLS?.CompanyId]) {
            const n = tryNum(c);
            if (n > 0) { CompId = n; break; }
        }
    }

    const CURRENT_USER_ID = Number(loggedInUser?.UserId ?? loggedInUser?.UserID ?? 0);
    const toMySqlDT = (d) => {
        const p = (n) => String(n).padStart(2, '0');
        return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
    };

    const getBookNameKey = (type, series = null) => {
        const base = type.replace(/\s+/g, '');
        if (series) {
            const seriesId = series?.SeriesId || series?.SeriesID || series?.seriesId || series?.Id || series?.id || 0;
            return `${base}_Series_${seriesId}`;
        }
        return base;
    };

    const getSeriesId = (series) => {
        return series?.SeriesId || series?.SeriesID || series?.seriesId || series?.Id || series?.id || 0;
    };

    // ✅ Build a unique key for appliedVariantMap
    const buildVariantKey = useCallback((format, pageSize, type, series = null) => {
        const typeKey = (type || '').replace(/\s+/g, '');
        const seriesKey = series ? `_s${getSeriesId(series)}` : '';
        const psKey = pageSize ? `_${pageSize}` : '';
        return `${typeKey}${seriesKey}_f${format}${psKey}`;
    }, []);

    // ✅ Build a unique key for pageSizeMap: type + optional series + format
    const buildPageSizeKey = useCallback((format, type, series = null) => {
        const typeKey = (type || '').replace(/\s+/g, '');
        const seriesKey = series ? `_s${getSeriesId(series)}` : '';
        return `${typeKey}${seriesKey}_f${format}`;
    }, []);

    // ✅ Get current page size — only meaningful for Sale Challan + format 11/12/13
    const currentPageSize = useCallback((format, type, series) => {
        if (!shouldShowPageSize(type, format)) return 'A4'; // default, not used
        const key = buildPageSizeKey(format, type, isMultiSeriesType ? series : null);
        return pageSizeMap[key] || 'A4'; // default A4
    }, [pageSizeMap, buildPageSizeKey, isMultiSeriesType]);

    // ── Sync signatureChecked from fresh companies API (not cached context) ──────────────
    useEffect(() => {
        if (!selectedType || !CompId) {
            setSignatureChecked(false);
            return;
        }

        const fetchSignatureStatus = async () => {
            try {
                // ✅ Fetch fresh format data with cache-buster
                const cacheBreaker = new Date().getTime();
                const resp = await axios.get(`${API}/api/companies`, {
                    params: { companyId: CompId, t: cacheBreaker },
                    timeout: 15000,
                });

                let comps = [];
                if (resp?.data) {
                    if (Array.isArray(resp.data.companies)) comps = resp.data.companies;
                    else if (Array.isArray(resp.data)) comps = resp.data;
                    else if (Array.isArray(resp.data.data)) comps = resp.data.data;
                }

                const norm = (s) => String(s || '').replace(/\s+/g, '').toLowerCase();
                const wantedBookName = norm(effectiveBookName);
                const wantedId = Number(CompId || 0);

                let matchedFormat = null;
                for (const c of comps) {
                    if (Number(c?.CompId ?? c?.CompID ?? 0) === wantedId && Array.isArray(c.formats)) {
                        for (const f of c.formats) {
                            const fBookName = norm(f.BookName || f.bookName || '');
                            const fSeriesId = Number(f.SeriesId || f.seriesId || 0);

                            if (isMultiSeriesType && selectedSeries && !isBookWiseType) {
                                const sId = getSeriesId(selectedSeries);
                                if (fBookName === wantedBookName && fSeriesId === Number(sId)) {
                                    matchedFormat = f;
                                    break;
                                }
                            } else {
                                if (fBookName === wantedBookName) {
                                    matchedFormat = f;
                                    break;
                                }
                            }
                        }
                        if (matchedFormat) break;
                    }
                }

                // ✅ Use matched format's Signature (fresh from API)
                setSignatureChecked(matchedFormat ? !!matchedFormat.Signature : false);
            } catch (err) {
                console.warn('Error fetching signature status from API:', err?.message);
                setSignatureChecked(false);
            }
        };

        fetchSignatureStatus();
    }, [selectedType, selectedSeries, appliedFormat, CompId]);

    // ── Sync qrCodeChecked from fresh companies API (Sale Invoice only, not cached context) ────
    useEffect(() => {
        if (!selectedType || !CompId) {
            setQrCodeChecked(false);
            return;
        }

        // Only show QR code checkbox for Sale Invoice
        const norm = (s) => String(s || '').replace(/\s+/g, '').toLowerCase();
        if (norm(selectedType) !== 'saleinvoice') {
            setQrCodeChecked(false);
            return;
        }

        const fetchQRCodeStatus = async () => {
            try {
                // ✅ Fetch fresh format data with cache-buster
                const cacheBreaker = new Date().getTime();
                const resp = await axios.get(`${API}/api/companies`, {
                    params: { companyId: CompId, t: cacheBreaker },
                    timeout: 15000,
                });

                let comps = [];
                if (resp?.data) {
                    if (Array.isArray(resp.data.companies)) comps = resp.data.companies;
                    else if (Array.isArray(resp.data)) comps = resp.data;
                    else if (Array.isArray(resp.data.data)) comps = resp.data.data;
                }

                const wantedBookName = norm(effectiveBookName);
                const wantedId = Number(CompId || 0);

                let matchedFormat = null;
                for (const c of comps) {
                    if (Number(c?.CompId ?? c?.CompID ?? 0) === wantedId && Array.isArray(c.formats)) {
                        for (const f of c.formats) {
                            const fBookName = norm(f.BookName || f.bookName || '');
                            const fSeriesId = Number(f.SeriesId || f.seriesId || 0);

                            if (isMultiSeriesType && selectedSeries && !isBookWiseType) {
                                const sId = getSeriesId(selectedSeries);
                                if (fBookName === wantedBookName && fSeriesId === Number(sId)) {
                                    matchedFormat = f;
                                    break;
                                }
                            } else {
                                if (fBookName === wantedBookName) {
                                    matchedFormat = f;
                                    break;
                                }
                            }
                        }
                        if (matchedFormat) break;
                    }
                }

                // ✅ Use matched format's QRCode (fresh from API)
                setQrCodeChecked(matchedFormat ? !!matchedFormat.QRCode : false);
            } catch (err) {
                console.warn('Error fetching QRCode status from API:', err?.message);
                setQrCodeChecked(false);
            }
        };

        fetchQRCodeStatus();
    }, [selectedType, selectedSeries, appliedFormat, CompId]);

    // ── Sync selectedColor from fresh companies API ────
    useEffect(() => {
        if (!selectedType || !CompId) {
            setSelectedColor(themeColors.neutral.black);
            setUserSelectedColor(null);
            return;
        }

        const fetchColorStatus = async () => {
            try {
                const cacheBreaker = new Date().getTime();
                const resp = await axios.get(`${API}/api/companies`, {
                    params: { companyId: CompId, t: cacheBreaker },
                    timeout: 15000,
                });

                let comps = [];
                if (resp?.data) {
                    if (Array.isArray(resp.data.companies)) comps = resp.data.companies;
                    else if (Array.isArray(resp.data)) comps = resp.data;
                    else if (Array.isArray(resp.data.data)) comps = resp.data.data;
                }

                const norm = (s) => String(s || '').replace(/\s+/g, '').toLowerCase();
                const wantedBookName = norm(effectiveBookName);
                const wantedId = Number(CompId || 0);

                let matchedFormat = null;
                for (const c of comps) {
                    if (Number(c?.CompId ?? c?.CompID ?? 0) === wantedId && Array.isArray(c.formats)) {
                        for (const f of c.formats) {
                            const fBookName = norm(f.BookName || f.bookName || '');
                            const fSeriesId = Number(f.SeriesId || f.seriesId || 0);

                            if (isMultiSeriesType && selectedSeries && !isBookWiseType) {
                                const sId = getSeriesId(selectedSeries);
                                if (fBookName === wantedBookName && fSeriesId === Number(sId)) {
                                    matchedFormat = f;
                                    break;
                                }
                            } else {
                                if (fBookName === wantedBookName) {
                                    matchedFormat = f;
                                    break;
                                }
                            }
                        }
                        if (matchedFormat) break;
                    }
                }

                // ✅ If user hasn't selected a color for this format yet, use saved color or default to black
                // If user previously selected a color (userSelectedColor is set), use that instead
                const colorFromDB = matchedFormat?.Color || themeColors.neutral.black;
                const colorToUse = userSelectedColor || colorFromDB;
                setSelectedColor(colorToUse);
            } catch (err) {
                console.warn('Error fetching color status from API:', err?.message);
                setSelectedColor(userSelectedColor || themeColors.neutral.black);
            }
        };

        fetchColorStatus();
    }, [selectedType, selectedSeries, appliedFormat, CompId]);

    const handleSignatureChange = async (e) => {
        const checked = e.target.checked;
        setSignatureChecked(checked);
        try {
            const bookName = effectiveBookName.replace(/\s+/g, '');
            const seriesId = isMultiSeriesType && selectedSeries && !isBookWiseType ? getSeriesId(selectedSeries) : null;
            await axios.put(`${API}/api/printmaster/signature`, {
                CompId,
                BookName: bookName,
                SeriesId: seriesId,
                Signature: checked ? 1 : 0,
                EditUserId: CURRENT_USER_ID,
            }, { headers: { 'Content-Type': 'application/json' }, timeout: 15000 });

            // ✅ Success - no need to reload, local state is already updated
            console.log('[Signature] Updated successfully');
        } catch (err) {
            console.error('[Signature Update Error]', {
                status: err.response?.status,
                data: err.response?.data,
                message: err.message
            });
            setSignatureChecked(!checked);
            setSnack({ open: true, msg: 'Failed to update signature setting.', severity: 'error' });
        }
    };

    // ── Handle QR Code toggle (Sale Invoice only) ──────────────────────────────
    const handleQRCodeChange = async (e) => {
        const checked = e.target.checked;
        setQrCodeChecked(checked);
        try {
            const bookName = effectiveBookName.replace(/\s+/g, '');
            const seriesId = isMultiSeriesType && selectedSeries && !isBookWiseType ? getSeriesId(selectedSeries) : null;
            await axios.put(`${API}/api/printmaster/qrcode`, {
                CompId,
                BookName: bookName,
                SeriesId: seriesId,
                QRCode: checked ? 1 : 0,
                EditUserId: CURRENT_USER_ID,
            }, { headers: { 'Content-Type': 'application/json' }, timeout: 15000 });

            // ✅ Success - no need to reload, local state is already updated
            console.log('[QR Code] Updated successfully');
        } catch (err) {
            console.error('[QR Code Update Error]', {
                status: err.response?.status,
                data: err.response?.data,
                message: err.message
            });
            setQrCodeChecked(!checked);
            setSnack({ open: true, msg: 'Failed to update QR code setting.', severity: 'error' });
        }
    };

    // ── Handle Color change ──────────────────────────────────────────────────────
    const handleColorChange = async (color) => {
        setSelectedColor(color);
        // ✅ Track user's explicit color selection
        setUserSelectedColor(color);
        setColorAnchor(null);
        try {
            const bookName = effectiveBookName.replace(/\s+/g, '');
            const seriesId = isMultiSeriesType && selectedSeries && !isBookWiseType ? getSeriesId(selectedSeries) : null;
            await axios.put(`${API}/api/printmaster/color`, {
                CompId,
                BookName: bookName,
                SeriesId: seriesId,
                Color: color,
                EditUserId: CURRENT_USER_ID,
            }, { headers: { 'Content-Type': 'application/json' }, timeout: 15000 });

            console.log('[Color] Updated successfully to', color);
            setSnack({ open: true, msg: `Color updated to ${color}`, severity: 'success' });
        } catch (err) {
            console.error('[Color Update Error]', {
                status: err.response?.status,
                data: err.response?.data,
                message: err.message
            });
            setSnack({ open: true, msg: 'Failed to update color setting.', severity: 'error' });
            // Revert on error
            setSelectedColor(selectedColor);
            setUserSelectedColor(null);
        }
    };

    // ✅ Predefined colors list (BLACK as default)
    const COLORS = [
        // Deep/Dark Colors - Maximum Contrast
        { name: 'Black', hex: themeColors.neutral.black, rgb: '(0,0,0)' },
        { name: 'White', hex: themeColors.neutral.surface, rgb: '(255,255,255)' },
        { name: 'Light Gray', hex: '#959e9e', rgb: '(149,158,158)' },
        { name: 'Dark Gray', hex: '#4e5454', rgb: '(78,84,84)' },
        { name: 'Navy Blue', hex: '#0D1B3C', rgb: '(13,27,60)' },
        { name: 'Deep Indigo', hex: '#1A0A33', rgb: '(26,10,51)' },

        // Bold Primary Blues - Strong Contrast
        { name: 'Royal Blue', hex: themeColors.primary.dark, rgb: '(21,101,192)' },
        { name: 'Bright Cyan', hex: '#00BCD4', rgb: '(0,188,212)' },

        // Green Family - Distinct shades
        { name: 'Teal', hex: '#009688', rgb: '(0,150,136)' },
        { name: 'Forest Green', hex: '#1B5E20', rgb: '(27,94,32)' },
        { name: 'Lime Green', hex: '#76FF03', rgb: '(118,255,3)' },

        // Purple & Pink
        { name: 'Purple', hex: '#7B1FA2', rgb: '(123,31,162)' },
        { name: 'Deep Pink', hex: '#C2185B', rgb: '(194,24,91)' },

        // Red & Orange
        { name: 'Red', hex: themeColors.error.dark, rgb: '(211,47,47)' },
        { name: 'Deep Orange', hex: '#E64A19', rgb: '(230,74,25)' },
        { name: 'Amber', hex: '#FFC107', rgb: '(255,193,7)' },

        // Dark/Bold Colors - High Contrast Alternative
        { name: 'Dark Cyan', hex: '#006064', rgb: '(0,96,100)' },
        { name: 'Dark Green', hex: '#004D40', rgb: '(0,77,64)' },
        { name: 'Dark Olive', hex: '#33691E', rgb: '(51,105,30)' },
        { name: 'Dark Yellow', hex: '#F57F17', rgb: '(245,127,23)' },
        { name: 'Maroon', hex: '#800000', rgb: '(128,0,0)' },
        { name: 'Dark Blue', hex: '#01579B', rgb: '(1,87,155)' },
        { name: 'Dark Purple', hex: '#4A148C', rgb: '(74,20,140)' },
        { name: 'Dark Red', hex: themeColors.error.darker, rgb: '(183,28,28)' },
    ];

    // ✅ Track if user has explicitly selected a color for current format
    const [userSelectedColor, setUserSelectedColor] = useState(null);

    // ── Fetch series ──────────────────────────────────────────────────────────
    const fetchSeriesForType = async (type) => {
        setLoadingSeries(true);
        setSeriesList([]);
        setSelectedSeries(null);
        setSeriesFormats({});
        setSeriesPageSizes({});
        // Book-wise type (Payable-Receivable): list the four books and load each book's saved format (default Format 1).
        if (BOOKWISE_TYPES.includes(type)) {
            setSeriesList(PAY_RECEIVE_BOOKS);
            try {
                const cacheBreaker = new Date().getTime();
                const fmtResp = await axios.get(`${API}/api/companies`, {
                    params: { companyId: CompId || 0, t: cacheBreaker },
                    timeout: 15000,
                });
                let companies = [];
                if (fmtResp?.data) {
                    if (Array.isArray(fmtResp.data.companies)) companies = fmtResp.data.companies;
                    else if (Array.isArray(fmtResp.data)) companies = fmtResp.data;
                    else if (Array.isArray(fmtResp.data.data)) companies = fmtResp.data.data;
                }
                const wantedId = Number(CompId || 0);
                const rec = companies.find(c => tryNum(c?.CompId ?? c?.CompID ?? 0) === wantedId) || companies[0];
                const norm = (s) => String(s || '').replace(/\s+/g, '').toLowerCase();
                const fmtMap = {};
                const pageSizeMap = {};
                PAY_RECEIVE_BOOKS.forEach((book) => {
                    const sId = getSeriesId(book);
                    const saved = (rec?.formats || []).find(f => norm(f?.BookName) === norm(book.BookCode) && Number(f?.BookID ?? f?.BookId ?? 0));
                    fmtMap[sId] = saved ? Number(saved.BookID ?? saved.BookId) : 1;
                    pageSizeMap[sId] = saved?.PageSize || null;
                });
                setSeriesFormats(fmtMap);
                setSeriesPageSizes(pageSizeMap);
            } catch (err) {
                console.warn('Error fetching Payable-Receivable formats', err?.message);
            } finally {
                setLoadingSeries(false);
            }
            return;
        }
        try {
            const companyIdParam = CompId || 0;
            const typeNorm = type.replace(/\s+/g, '');
            const resp = await axios.get(`${API}/api/seriesForPDF`, {
                params: { companyId: companyIdParam, documentType: typeNorm },
                timeout: 15000,
            });

            let arr = [];
            if (resp?.data) {
                if (Array.isArray(resp.data.series)) arr = resp.data.series;
                else if (Array.isArray(resp.data)) arr = resp.data;
                else if (Array.isArray(resp.data.data)) arr = resp.data.data;
            }
            setSeriesList(arr);

            if (arr.length > 0) {
                try {
                    // ✅ Add cache-buster to get fresh data
                    const cacheBreaker = new Date().getTime();
                    const fmtResp = await axios.get(`${API}/api/companies`, {
                        params: { companyId: companyIdParam, t: cacheBreaker },
                        timeout: 15000,
                    });
                    let companies = [];
                    if (fmtResp?.data) {
                        if (Array.isArray(fmtResp.data.companies)) companies = fmtResp.data.companies;
                        else if (Array.isArray(fmtResp.data)) companies = fmtResp.data;
                        else if (Array.isArray(fmtResp.data.data)) companies = fmtResp.data.data;
                    }
                    const wantedId = Number(CompId || companyIdParam || 0);
                    const rec = companies.find(c => tryNum(c?.CompId ?? c?.CompID ?? 0) === wantedId) || companies[0];
                    if (rec && Array.isArray(rec.formats)) {
                        const norm = (s) => String(s || '').replace(/\s+/g, '').toLowerCase();
                        const fmtMap = {};
                        const pageSizeMap = {};
                        for (const series of arr) {
                            const sId = getSeriesId(series);
                            const wantedBookName = norm(typeNorm);
                            for (const f of rec.formats) {
                                const bName = norm(f?.BookName ?? '');
                                const bId = Number(f?.BookID ?? f?.BookId ?? 0);
                                const fSeriesId = Number(f?.SeriesId ?? f?.seriesId ?? 0);
                                if (bId && bName === wantedBookName && fSeriesId === Number(sId)) {
                                    fmtMap[sId] = bId;
                                    pageSizeMap[sId] = f?.PageSize || null;
                                    break;
                                }
                            }
                            if (!fmtMap[sId]) {
                                for (const f of rec.formats) {
                                    const bName = norm(f?.BookName ?? '');
                                    const bId = Number(f?.BookID ?? f?.BookId ?? 0);
                                    const fSeriesId = Number(f?.SeriesId ?? f?.seriesId ?? 0);
                                    if (bId && bName === wantedBookName && (!fSeriesId || fSeriesId === 0)) {
                                        fmtMap[sId] = bId;
                                        pageSizeMap[sId] = f?.PageSize || null;
                                        break;
                                    }
                                }
                            }
                        }
                        setSeriesFormats(fmtMap);
                        setSeriesPageSizes(pageSizeMap);
                    }
                } catch (err) {
                    console.warn('Error fetching series formats', err?.message);
                }
            }
        } catch (err) {
            console.warn('Series API error', err?.response?.data || err?.message);
            setSeriesList([]);
            setSelectedSeries(null);
            setSeriesFormats({});
            setSeriesPageSizes({});
            setSnack({ open: true, msg: err?.response?.data?.message || 'Failed to load series.', severity: 'error' });
        } finally {
            setLoadingSeries(false);
        }
    };

    // ── Handlers ─────────────────────────────────────────────────────────────
    const handleSelectType = async (type) => {
        // ✅ Update format count based on selected type
        const formatCount = getFormatCount(type);
        setCurrentFormatCount(formatCount);

        setSelectedType(type);
        setSelectedFormat(null);
        setSelectedCardPageSize(null);
        setAppliedFormat(null);
        setAppliedPageSize(null);
        setSelectedSeries(null);
        setSeriesList([]);
        setSeriesFormats({});
        setSeriesPageSizes({});
        setAppliedVariantMap({});
        // ✅ Reset user color selection when changing document type
        setUserSelectedColor(null);
        setSelectedColor(themeColors.neutral.black);

        if (MULTI_SERIES_TYPES.includes(type)) {
            await fetchSeriesForType(type);
        } else {
            try {
                const companyIdParam = CompId || 0;
                // ✅ Add cache-buster to get fresh data
                const cacheBreaker = new Date().getTime();
                const resp = await axios.get(`${API}/api/companies`, { params: { companyId: companyIdParam, t: cacheBreaker }, timeout: 15000 });
                let arr = [];
                if (resp?.data) {
                    if (Array.isArray(resp.data.companies)) arr = resp.data.companies;
                    else if (Array.isArray(resp.data)) arr = resp.data;
                    else if (Array.isArray(resp.data.data)) arr = resp.data.data;
                }
                const wantedId = Number(CompId || companyIdParam || 0);
                const rec = arr.find(c => tryNum(c?.CompId ?? c?.CompID ?? 0) === wantedId) || arr[0];
                if (rec && Array.isArray(rec.formats)) {
                    const norm = (s) => String(s || '').replace(/\s+/g, '').toLowerCase();
                    const wantedNorm = norm(type);
                    let found = null;
                    let foundPageSize = null;
                    for (const f of rec.formats) {
                        const bName = norm(f?.BookName ?? '');
                        const bId = Number(f?.BookID ?? f?.BookId ?? 0);
                        if (bId && bName === wantedNorm) {
                            found = bId;
                            foundPageSize = f?.PageSize || null;
                            break;
                        }
                    }
                    setAppliedFormat(found ?? 1);
                    setAppliedPageSize(foundPageSize);
                } else {
                    setAppliedFormat(1);
                    setAppliedPageSize(null);
                }
            } catch (err) {
                console.warn('companies API error', err?.message);
            }
        }
    };

    const handleSelectSeries = (series) => {
        setSelectedSeries(series);
        setSelectedFormat(null);
        setSelectedCardPageSize(null);
        const sId = getSeriesId(series);
        const fmt = seriesFormats[sId] || null;
        const pageSize = seriesPageSizes[sId] || null;
        setAppliedFormat(fmt);
        setAppliedPageSize(pageSize);
        // ✅ Reset user color selection when changing series (will fetch from API in useEffect)
        setUserSelectedColor(null);
    };

    // ✅ handleCardClick receives both format and pageSize from the card
    const handleCardClick = (format, pageSize) => {
        setSelectedFormat(format);
        setSelectedCardPageSize(pageSize); // null for non-variant, 'A4'/'A5' for variant cards
        setPreviewOpen(true);
    };

    // ✅ Helper: check if a specific format+pageSize variant card is applied
    const isVariantApplied = useCallback((format, pageSize, type, series) => {
        if (!shouldShowPageSize(type, format)) {
            // Non-variant (formats 1–10, including ALL PAGE_SIZE_DOCUMENT_TYPES display-only A4):
            // just check appliedFormat — pageSize logic unchanged
            return appliedFormat === format;
        }
        // Variant card (formats 11–13): check both appliedFormat AND appliedPageSize
        return appliedFormat === format && appliedPageSize === pageSize;
    }, [appliedFormat, appliedPageSize]);

    const handleApplyTemplate = async () => {
        if (!selectedType || !selectedFormat) {
            setSnack({ open: true, msg: 'Select a document type and format first.', severity: 'warning' });
            return;
        }
        if (isMultiSeriesType && !selectedSeries) {
            setSnack({ open: true, msg: 'Please select a series first.', severity: 'warning' });
            return;
        }
        if (!CompId) {
            setSnack({ open: true, msg: 'Unable to determine your company. Please select a company first.', severity: 'error' });
            return;
        }

        const now = new Date();
        const bookName = effectiveBookName.replace(/\s+/g, '');
        const seriesId = isMultiSeriesType && !isBookWiseType ? getSeriesId(selectedSeries) : null;

        // ✅ Determine PageSize to send — only for Sale Challan/Purchase Dispatch + format 11/12/13
        const isPageSizeApplicable = shouldShowPageSize(selectedType, selectedFormat);
        // ✅ Use selectedCardPageSize (set when card was clicked) as the effective page size — fixed, not changeable
        const effectivePageSize = isPageSizeApplicable
            ? (selectedCardPageSize || 'A4')
            : null;

        // ✅ Use selectedColor (which is #000000 by default if not changed), or preserve user's previous selection
        const colorToStore = selectedColor || themeColors.neutral.black;

        const payload = {
            GCompId: null, CompId,
            BookName: bookName,
            BookID: Number(selectedFormat),
            FormName: isBookWiseType
                ? `${selectedType}-${effectiveBookName}-Format-${selectedFormat}`
                : isMultiSeriesType
                ? `${selectedType}-Series-${seriesId}-Format-${selectedFormat}`
                : `${selectedType}-Format-${selectedFormat}`,
            CompDefault: 0, PPO: 0,
            paperheight: 842, paperwidth: 595,
            TopMargin: 0, LeftMargin: 0, RightMargin: 0, BottomMargin: 0,
            Heading: '',
            AddUserId: CURRENT_USER_ID, AddUserDateTime: toMySqlDT(now),
            EditUserId: CURRENT_USER_ID, EditUserDateTime: toMySqlDT(now),
            AppRegID,
            ...(isMultiSeriesType && seriesId ? { SeriesId: seriesId } : {}),
            // ✅ Include PageSize only for Sale Challan/Purchase Dispatch + format 11/12/13
            ...(isPageSizeApplicable && effectivePageSize ? { PageSize: effectivePageSize } : {}),
            // ✅ Always include color in payload (default black #000000 if not selected)
            Color: colorToStore,
        };

        try {
            const res = await axios.post(`${API}/api/printmaster`, payload, { headers: { 'Content-Type': 'application/json' }, timeout: 15000 });
            const ok = res?.data?.success === true || res?.data?.insertId || (res?.data?.affectedRows > 0);
            if (ok) {
                const newFormat = Number(selectedFormat);
                setAppliedFormat(newFormat);

                if (isPageSizeApplicable && effectivePageSize) {
                    setAppliedPageSize(effectivePageSize);
                    // ✅ Mark this specific variant as applied
                    const variantKey = buildVariantKey(newFormat, effectivePageSize, selectedType, isMultiSeriesType ? selectedSeries : null);
                    setAppliedVariantMap(prev => ({ ...prev, [variantKey]: true }));
                } else {
                    setAppliedPageSize(null);
                }

                if (isMultiSeriesType && selectedSeries) {
                    const sId = getSeriesId(selectedSeries);
                    setSeriesFormats(prev => ({ ...prev, [sId]: newFormat }));
                }
                setPreviewOpen(false);
                setSelectedFormat(null);
                setSelectedCardPageSize(null);
                const seriesLabel = isMultiSeriesType && selectedSeries
                    ? ` for ${selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || 'series'}`
                    : '';
                // ✅ Include page size in success message when applicable
                const pageSizeLabel = isPageSizeApplicable && effectivePageSize
                    ? ` (${effectivePageSize})`
                    : '';
                setSnack({
                    open: true,
                    msg: `Format ${selectedFormat}${pageSizeLabel} applied successfully${seriesLabel}!`,
                    severity: 'success',
                });
            } else {
                setSnack({ open: true, msg: res?.data?.message || 'Failed to apply template.', severity: 'error' });
            }
        } catch (err) {
            const msg = err.response?.data?.message || `Server error ${err.response?.status || ''}` || 'Network error.';
            setSnack({ open: true, msg, severity: 'error' });
        }
    };

    const showFormatGrid = selectedType && (!isMultiSeriesType || (isMultiSeriesType && selectedSeries));

    const getActiveFormatLabel = () => {
        if (isMultiSeriesType && selectedSeries) {
            const sId = getSeriesId(selectedSeries);
            const fmt = seriesFormats[sId];
            if (fmt) {
                const sName = selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || `Series ${sId}`;
                return `Format ${fmt} — ${sName}`;
            }
            return null;
        }
        if (appliedFormat && selectedType && !isMultiSeriesType) {
            // ✅ Include page size in label if applicable
            if (appliedPageSize && shouldShowPageSize(selectedType, appliedFormat)) {
                return `Format ${appliedFormat} (${appliedPageSize}) active`;
            }
            return `Format ${appliedFormat} active`;
        }
        return null;
    };

    const activeLabel = getActiveFormatLabel();

    // ✅ Build the expanded format list for the current type
    const formatList = buildFormatList(selectedType, currentFormatCount);

    // ─── RENDER ───────────────────────────────────────────────────────────────
    return (
        <Box sx={{ minHeight: "100vh", background: BG }}>

            {/* ── Top bar ── */}
            <Box sx={{ position: "sticky", top: 0, zIndex: 5, bgcolor: "rgba(255,255,255,0.86)", backdropFilter: "blur(12px)", borderBottom: `1px solid ${BORDER_SOFT}` }}>
                <Box sx={{ maxWidth: 1320, mx: "auto", px: { xs: 2, sm: 3, md: 4 }, py: 1.6, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, flexWrap: "wrap" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        <Box sx={{ width: 38, height: 38, borderRadius: "12px", background: GRAD_BRAND, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: SHADOW_BRAND }}>
                            <FilePresent sx={{ fontSize: 20, color: themeColors.neutral.surface }} />
                        </Box>
                        <Box>
                            <Typography sx={{ fontSize: 16.5, fontWeight: 800, color: T1, letterSpacing: "-0.3px", lineHeight: 1.2 }}>Printing utilities</Typography>
                            <Typography sx={{ fontSize: 12, color: T2 }}>
                                Document templates{companyObj?.CompanyName ? ` · ${companyObj.CompanyName}` : ""}
                            </Typography>
                        </Box>
                    </Box>
                    {activeLabel && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.8, px: 1.4, py: 0.7, borderRadius: "999px", bgcolor: GREEN_LT, border: `1px solid ${GREEN_BORDER}` }}>
                            <Box sx={{ width: 7, height: 7, borderRadius: "50%", bgcolor: GREEN, boxShadow: "0 0 0 3px rgba(18,128,92,0.15)" }} />
                            <Typography sx={{ fontSize: 12, fontWeight: 700, color: GREEN }}>{activeLabel}</Typography>
                        </Box>
                    )}
                </Box>
            </Box>

            <Box sx={{ maxWidth: 1320, mx: "auto", px: { xs: 2, sm: 3, md: 4 }, py: { xs: 2.5, md: 3.5 }, display: "flex", flexDirection: { xs: "column", md: "row" }, gap: { xs: 2.5, md: 3 }, alignItems: "flex-start" }}>

                {/* ── Document type rail ── */}
                <Box component="nav" aria-label="Document types" sx={{ width: { xs: "100%", md: 240 }, flexShrink: 0, position: { md: "sticky" }, top: { md: 84 } }}>
                    <Typography sx={{ fontSize: 11, fontWeight: 700, color: T3, letterSpacing: "0.8px", textTransform: "uppercase", px: 1.2, mb: 1 }}>Document types</Typography>
                    <Box sx={{ display: "flex", flexDirection: { xs: "row", md: "column" }, gap: 0.6, overflowX: { xs: "auto", md: "visible" }, pb: { xs: 0.5, md: 0 } }}>
                        {visibleDocumentTypes.map((type) => {
                            const isActive = selectedType === type;
                            const isMulti = MULTI_SERIES_TYPES.includes(type);
                            const hasApplied = isActive && !!appliedFormat;
                            const DocIcon = getDocTypeIcon(type);
                            return (
                                <Box
                                    key={type}
                                    role="button"
                                    tabIndex={0}
                                    onClick={() => handleSelectType(type)}
                                    onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); handleSelectType(type); } }}
                                    sx={{
                                        display: "flex", alignItems: "center", gap: 1.2, px: 1.2, py: 1, borderRadius: "12px", cursor: "pointer", flexShrink: 0, minWidth: { xs: 160, md: "auto" },
                                        bgcolor: isActive ? themeColors.neutral.surface : "transparent",
                                        boxShadow: isActive ? SHADOW_SM : "none",
                                        transition: `all 0.22s ${EASE}`,
                                        "&:hover": { bgcolor: isActive ? themeColors.neutral.surface : "rgba(255,255,255,0.7)" },
                                        "&:focus-visible": { outline: `2px solid ${FB}`, outlineOffset: 2 },
                                    }}
                                >
                                    <Box sx={{ width: 32, height: 32, borderRadius: "10px", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", background: isActive ? GRAD_BRAND : "#E6EDF4", transition: `all 0.22s ${EASE}` }}>
                                        <DocIcon sx={{ fontSize: 16, color: isActive ? themeColors.neutral.surface : T2 }} />
                                    </Box>
                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                        <Typography noWrap sx={{ fontSize: 13.5, fontWeight: isActive ? 700 : 600, color: isActive ? FB_DARK : T1 }}>{type}</Typography>
                                        {isMulti && <Typography sx={{ fontSize: 10.5, color: T3, fontWeight: 600 }}>Multi-series</Typography>}
                                    </Box>
                                    {hasApplied && <Box sx={{ width: 7, height: 7, borderRadius: "50%", bgcolor: GREEN, flexShrink: 0 }} />}
                                </Box>
                            );
                        })}
                    </Box>
                </Box>

                {/* ── Main panel ── */}
                <Box sx={{ flex: 1, minWidth: 0, width: "100%", display: "flex", flexDirection: "column", gap: 2 }}>

                    {/* Series selector */}
                    {isMultiSeriesType && selectedType && (
                        <Fade in={isMultiSeriesType}>
                            <Box sx={{ bgcolor: SURFACE, borderRadius: "18px", border: `1px solid ${BORDER_SOFT}`, boxShadow: SHADOW_XS, p: { xs: 2, sm: 2.5 } }}>
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1.5, flexWrap: "wrap", mb: 1.8 }}>
                                    <Box>
                                        <Typography sx={{ fontSize: 14.5, fontWeight: 800, color: T1, letterSpacing: "-0.2px" }}>{isBookWiseType ? "Book" : "Series"}</Typography>
                                        <Typography sx={{ fontSize: 12, color: T2, mt: 0.2 }}>{isBookWiseType ? "Each book can use its own template." : "Each series can use its own template."}</Typography>
                                    </Box>
                                    {selectedSeries && (
                                        <Box sx={{ px: 1.2, py: 0.5, borderRadius: "999px", bgcolor: FB_SOFT, border: `1px solid ${FB_MID}` }}>
                                            <Typography sx={{ fontSize: 11.5, fontWeight: 700, color: FB }}>
                                                {selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || "Selected"}
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>

                                {loadingSeries ? (
                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", py: 4, gap: 1.2 }}>
                                        <CircularProgress size={18} thickness={4} sx={{ color: FB }} />
                                        <Typography sx={{ fontSize: 12, color: T2, fontWeight: 500 }}>Loading series…</Typography>
                                    </Box>
                                ) : seriesList.length > 0 ? (
                                    <Grid container spacing={1.2}>
                                        {seriesList.map((series, index) => {
                                            const sId = getSeriesId(series);
                                            const isSelected = selectedSeries && getSeriesId(selectedSeries) === sId;
                                            const sAppliedFormat = seriesFormats[sId] || null;
                                            return (
                                                <Grid item key={sId} xs={6} sm={6} md={3}>
                                                    <SeriesCard series={series} isSelected={isSelected} appliedFormat={sAppliedFormat} onClick={handleSelectSeries} index={index} />
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                ) : (
                                    <Box sx={{ py: 4, textAlign: "center", borderRadius: "14px", bgcolor: SURFACE_ALT, border: `1px dashed ${BORDER}` }}>
                                        <Typography sx={{ fontSize: 13.5, fontWeight: 700, color: T1, mb: 0.4 }}>No series found</Typography>
                                        <Typography sx={{ fontSize: 12.5, color: T2 }}>No series available for {selectedType}. Create a series first.</Typography>
                                    </Box>
                                )}
                            </Box>
                        </Fade>
                    )}

                    {/* Format templates */}
                    {showFormatGrid ? (
                        <Fade in={showFormatGrid}>
                            <Box sx={{ bgcolor: SURFACE, borderRadius: "18px", border: `1px solid ${BORDER_SOFT}`, boxShadow: SHADOW_SM, overflow: "hidden" }}>

                                {/* Toolbar */}
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1.5, flexWrap: "wrap", px: { xs: 2, sm: 2.5 }, py: 1.6, borderBottom: `1px solid ${BORDER_SOFT}` }}>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                                        <Typography sx={{ fontSize: 14.5, fontWeight: 800, color: T1, letterSpacing: "-0.2px", mr: 0.5 }}>{selectedType}</Typography>
                                        {isMultiSeriesType && selectedSeries && (
                                            <Box sx={{ px: 1, py: 0.35, borderRadius: "999px", bgcolor: FB_SOFT }}>
                                                <Typography sx={{ fontSize: 11, fontWeight: 700, color: FB }}>{selectedSeries?.SeriesName || selectedSeries?.seriesName || selectedSeries?.Name || "Series"}</Typography>
                                            </Box>
                                        )}
                                        <Typography sx={{ fontSize: 11.5, color: T3 }}>{formatList.length} templates</Typography>
                                        {appliedFormat && (
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.6, px: 1, py: 0.35, borderRadius: "999px", bgcolor: GREEN_LT, border: `1px solid ${GREEN_BORDER}` }}>
                                                <CheckCircle sx={{ fontSize: 12, color: GREEN }} />
                                                <Typography sx={{ fontSize: 11, fontWeight: 700, color: GREEN }}>
                                                    FMT-{String(appliedFormat).padStart(2, "0")}
                                                    {appliedPageSize && shouldShowPageSize(selectedType, appliedFormat) && ` (${appliedPageSize})`}
                                                    {" "}active{isMultiSeriesType && selectedSeries ? " for this series" : ""}
                                                </Typography>
                                            </Box>
                                        )}
                                    </Box>

                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                                        <FormControlLabel
                                            control={<Checkbox checked={signatureChecked} onChange={handleSignatureChange} disabled={!appliedFormat} size="small" sx={{ color: FB_MID, "&.Mui-checked": { color: FB } }} />}
                                            label={<Typography sx={{ fontSize: 12, color: appliedFormat ? T1 : T3, fontWeight: 600 }}>{appliedFormat ? "Authorized signature" : "Apply a format first"}</Typography>}
                                            sx={{ mr: 0.5 }}
                                        />
                                        {selectedType && String(selectedType || "").replace(/\s+/g, "").toLowerCase() === "saleinvoice" && (
                                            <FormControlLabel
                                                control={<Checkbox checked={qrCodeChecked} onChange={handleQRCodeChange} disabled={!appliedFormat} size="small" sx={{ color: FB_MID, "&.Mui-checked": { color: FB } }} />}
                                                label={<Typography sx={{ fontSize: 12, color: appliedFormat ? T1 : T3, fontWeight: 600 }}>{appliedFormat ? "QR code" : "Apply a format first"}</Typography>}
                                                sx={{ mr: 0.5 }}
                                            />
                                        )}
                                        <Button
                                            onClick={(e) => setColorAnchor(e.currentTarget)}
                                            disabled={!appliedFormat}
                                            startIcon={<Box sx={{ width: 12, height: 12, borderRadius: "4px", bgcolor: selectedColor, border: "1px solid rgba(0,0,0,0.12)" }} />}
                                            sx={{ height: 32, px: 1.4, borderRadius: "10px", textTransform: "none", fontSize: 12, fontWeight: 600, color: appliedFormat ? T1 : T3, border: `1px solid ${BORDER}`, bgcolor: SURFACE, transition: `all 0.2s ${EASE}`, "&:hover": { bgcolor: SURFACE_ALT, borderColor: FB_MID } }}
                                        >
                                            {appliedFormat ? `Color ${selectedColor}` : "Apply a format first"}
                                        </Button>
                                        <Popover
                                            open={Boolean(colorAnchor)}
                                            anchorEl={colorAnchor}
                                            onClose={() => setColorAnchor(null)}
                                            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                            transformOrigin={{ vertical: "top", horizontal: "left" }}
                                            PaperProps={{ sx: { borderRadius: "16px", boxShadow: SHADOW_LG, border: `1px solid ${BORDER_SOFT}`, mt: 1 } }}
                                        >
                                            <Box sx={{ p: 2.2, bgcolor: SURFACE, maxWidth: 420 }}>
                                                <Typography sx={{ fontSize: 14, fontWeight: 800, color: T1, mb: 0.3 }}>Template color</Typography>
                                                <Typography sx={{ fontSize: 12, color: T2, mb: 1.8 }}>Choose an accent for this template</Typography>
                                                <Grid container spacing={1}>
                                                    {COLORS.map((color) => (
                                                        <Grid item xs={4} sm={3} key={color.hex}>
                                                            <Box
                                                                onClick={() => handleColorChange(color.hex)}
                                                                sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0.6, p: 1, borderRadius: "12px", cursor: "pointer", bgcolor: selectedColor === color.hex ? FB_SOFT : SURFACE_ALT, border: `1.5px solid ${selectedColor === color.hex ? FB : "transparent"}`, transition: `all 0.2s ${EASE}`, "&:hover": { transform: "translateY(-2px)", boxShadow: SHADOW_SM } }}
                                                            >
                                                                <Box sx={{ width: 36, height: 36, borderRadius: "10px", bgcolor: color.hex, boxShadow: SHADOW_XS, border: "1px solid rgba(0,0,0,0.06)" }} />
                                                                <Typography sx={{ fontSize: 10.5, fontWeight: 600, color: T1, textAlign: "center" }}>{color.name}</Typography>
                                                            </Box>
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1.8 }}>
                                                    <Button onClick={() => setColorAnchor(null)} sx={{ textTransform: "none", fontWeight: 700, fontSize: 12.5, color: FB, borderRadius: "10px", px: 1.6 }}>Done</Button>
                                                </Box>
                                            </Box>
                                        </Popover>
                                    </Box>
                                </Box>

                                {/* Template grid */}
                                <Box sx={{ p: { xs: 1.5, sm: 2.2 } }}>
                                    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", md: "repeat(4, minmax(0, 1fr))", xl: "repeat(5, minmax(0, 1fr))" }, gap: { xs: 1.2, sm: 1.6 } }}>
                                        {formatList.map((item, cardIndex) => {
                                            const cardIsApplied = isVariantApplied(item.format, item.pageSize, selectedType, isMultiSeriesType ? selectedSeries : null);
                                            return (
                                                <Box key={`${item.format}_${item.pageSize || "std"}`} sx={{ minWidth: 0 }}>
                                                    <FormatCard
                                                        format={item.format}
                                                        pageSize={item.pageSize}
                                                        badgePageSize={item.badgePageSize}
                                                        selectedType={selectedType}
                                                        isApplied={cardIsApplied}
                                                        onClick={() => handleCardClick(item.format, item.pageSize)}
                                                        cardIndex={cardIndex}
                                                    />
                                                </Box>
                                            );
                                        })}
                                    </Box>
                                </Box>
                            </Box>
                        </Fade>
                    ) : !selectedType ? (
                        <Box sx={{ bgcolor: SURFACE, borderRadius: "18px", border: `1px solid ${BORDER_SOFT}`, boxShadow: SHADOW_XS, py: { xs: 8, sm: 10 }, textAlign: "center" }}>
                            <Box sx={{ width: 56, height: 56, borderRadius: "18px", background: FB_SOFT, display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
                                <FilePresent sx={{ fontSize: 26, color: FB }} />
                            </Box>
                            <Typography sx={{ fontSize: 15, fontWeight: 800, color: T1, mb: 0.6 }}>Choose a document type</Typography>
                            <Typography sx={{ fontSize: 13, color: T2 }}>Pick one on the left to browse its templates</Typography>
                        </Box>
                    ) : isMultiSeriesType && !selectedSeries ? (
                        !loadingSeries && seriesList.length > 0 && (
                            <Box sx={{ bgcolor: SURFACE, borderRadius: "18px", border: `1px solid ${BORDER_SOFT}`, boxShadow: SHADOW_XS, py: { xs: 7, sm: 9 }, textAlign: "center" }}>
                                <Box sx={{ width: 56, height: 56, borderRadius: "18px", background: FB_SOFT, display: "flex", alignItems: "center", justifyContent: "center", mx: "auto", mb: 2 }}>
                                    <BarChart sx={{ fontSize: 26, color: FB }} />
                                </Box>
                                <Typography sx={{ fontSize: 15, fontWeight: 800, color: T1, mb: 0.6 }}>Choose a series</Typography>
                                <Typography sx={{ fontSize: 13, color: T2 }}>Select a series above to configure its template</Typography>
                            </Box>
                        )
                    ) : null}
                </Box>
            </Box>

            {/* ── Preview dialog ── */}
            <PreviewDialog
                open={previewOpen}
                onClose={() => { setPreviewOpen(false); setSelectedFormat(null); setSelectedCardPageSize(null); }}
                selectedType={selectedType}
                selectedFormat={selectedFormat}
                appliedFormat={appliedFormat}
                onApply={handleApplyTemplate}
                selectedSeries={selectedSeries}
                pageSize={selectedCardPageSize || "A4"}
                appliedPageSize={appliedPageSize}
            />

            {/* ── Snackbar ── */}
            <Snackbar open={snack.open} autoHideDuration={3500} onClose={() => setSnack((s) => ({ ...s, open: false }))} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
                <Alert severity={snack.severity} variant="filled" onClose={() => setSnack((s) => ({ ...s, open: false }))} sx={{ borderRadius: "12px", fontWeight: 600, fontSize: 13, boxShadow: SHADOW_LG }}>
                    {snack.msg}
                </Alert>
            </Snackbar>
        </Box>
    );
}